// // // src/components/ChatWidget.jsx
// // // FAQ answers are built from servicesConfig so they stay in sync with pricing/branding.
// // // Unknown questions collect name+email and POST to /email/support on the backend.

// // import { useState, useEffect, useRef } from "react";
// // import servicesConfig from "../utils/servicesConfig";

// // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";

// // // ── Pull live values from config so FAQ never goes stale ──
// // const cfg        = servicesConfig.app;
// // const basicPlan  = servicesConfig.plans.find(p => p.id === "ats_basic");
// // const docPlan    = servicesConfig.plans.find(p => p.id === "doc_pro");
// // const templates  = servicesConfig.resumeTemplates.filter(t => t.active && !t.comingSoon);
// // const PRICE      = basicPlan?.price        || "$2.99";
// // const ANALYSES   = basicPlan?.analysisCount || 2;
// // const RESUME_GEN = basicPlan?.resumeGenCount || 1;
// // const TMPL_COUNT = templates.length;
// // const SUPPORT_HR = cfg.supportHours        || "2-4 hours";
// // const APP_NAME   = cfg.name                || "ResumeScoreAI";
// // const APP_EMAIL  = cfg.email               || "support@smartaicareer.com";

// // // ── Enhanced FAQ with better responses and personality ──
// // const FAQ = [
// //   {
// //     keys: ["price","cost","how much","fee","charge","dollar","$","pricing"],
// //     q: "💰 How much does it cost?",
// //     a: `🎯 Great question! **${APP_NAME}** is just ${PRICE} — a **one-time payment**, no subscription ever.\n\n✨ What you get:\n• ${ANALYSES} full ATS analyses\n• ${RESUME_GEN} AI-improved resume\n• ${TMPL_COUNT} professional templates\n• Instant results\n\nThat's less than a coffee! ☕ → 💼`,
// //   },
// //   {
// //     keys: ["subscription","monthly","recurring","cancel","automatic","renew","billing"],
// //     q: "🔄 Is there a subscription?",
// //     a: `**No subscriptions — EVER!** 🙌\n\n✅ One-time payment only\n✅ No hidden fees\n✅ No automatic renewals\n✅ Keep what you buy forever\n\nPay once, use your credits, and that's it. Simple and fair. 💙`,
// //   },
// //   {
// //     keys: ["document pro","doc pro","second plan","upgrade","document summary"],
// //     q: "📊 What about Document Pro?",
// //     a: docPlan && docPlan.active
// //       ? `**Document Pro** is ${docPlan.price} one-time! 🚀\n\nIncludes:\n• ${docPlan.analysisCount || 3} ATS analyses\n• AI document summarization with charts\n• Document chat Q&A\n• ${RESUME_GEN} AI resume\n\nPerfect for analyzing reports, research papers, or long documents!`
// //       : `**Document Pro** (coming soon! 🎉) will include:\n• AI document summarization with visual charts\n• Interactive document chat/Q&A\n• ${ANALYSES * 2} ATS analyses\n\n📧 **Want early access?** Use the contact form below and we'll notify you when it launches!`,
// //   },
// //   {
// //     keys: ["ats","applicant tracking","ats score","what is ats","how ats works"],
// //     q: "🎯 What is an ATS score and why does it matter?",
// //     a: `**ATS** = Applicant Tracking System (software companies use to filter resumes).\n\n📊 **Your ATS Score (0-100)** measures how well your resume matches a job description.\n\n⚠️ **The harsh truth:** 75% of resumes are rejected by ATS before a human sees them — purely because of keyword mismatches!\n\n✅ **Score guide:**\n• 85-100: Excellent — You'll likely get an interview\n• 70-84: Good — Minor improvements needed\n• 50-69: Needs work — Missing key keywords\n• Below 50: Major overhaul needed\n\n🎯 **Our goal:** Get you to 75+ so recruiters actually see your resume!`,
// //   },
// //   {
// //     keys: ["include","what do i get","features","what's included","package","included"],
// //     q: "📦 What's included in ATS Basic?",
// //     a: `**ATS Basic (${PRICE})** includes everything you need:\n\n🔍 **Analyses (${ANALYSES} total):**\n• Full ATS score (0-100)\n• Keyword gap analysis\n• Section-by-section feedback\n• AI rewrite suggestions\n• Downloadable PDF report\n\n✨ **Resume Generation (${RESUME_GEN}):**\n• AI-improved resume using YOUR real data\n• ${TMPL_COUNT} professional templates\n• PDF + Word + HTML download\n• ATS-optimized formatting\n\n**Total value: ~$50** — you pay just ${PRICE}! 🎉`,
// //   },
// //   {
// //     keys: ["resume","generate","generator","template","improved","ai resume","optimize"],
// //     q: "✨ How does the AI resume generator work?",
// //     a: `**Magic happens in 3 steps:**\n\n1️⃣ **Analysis** — We scan your resume against the job description\n2️⃣ **Enhancement** — AI injects missing keywords naturally into YOUR real experience (real companies, real dates, real achievements!)\n3️⃣ **Generation** — You pick from ${TMPL_COUNT} beautiful templates and download instantly\n\n⏱️ **Takes 15-20 seconds** — no generic filler, just your improved resume ready to go!\n\n🎨 **Templates available:** ${templates.map(t => t.name).join(", ")}`,
// //   },
// //   {
// //     keys: ["multiple","2 analysis","two","analyze again","re-analyze","second analysis","more than one"],
// //     q: "🔄 Can I run multiple analyses?",
// //     a: `**Absolutely!** ATS Basic includes **${ANALYSES} full analyses** per purchase.\n\n💡 **Pro tip - Multi-Job Strategy:**\n1️⃣ Run analysis #1 with Job A\n2️⃣ Run analysis #2 with Job B  \n3️⃣ Compare both scores\n4️⃣ Generate your resume for the job with the highest match\n\n🎯 **Why this works:** Different jobs need different keywords. This strategy can increase interview chances by 3x!`,
// //   },
// //   {
// //     keys: ["low score","bad score","improve","better score","increase score","fix resume"],
// //     q: "📈 My score was low — how do I improve it?",
// //     a: `**Don't worry — that's why we're here!** 💪\n\n🔧 **Step-by-step improvement plan:**\n\n1️⃣ **Check "Missing Keywords"** — These are the specific words employers want\n2️⃣ **Add them naturally** — Integrate into your bullet points, don't just list them\n3️⃣ **Re-analyze** — Use your ${ANALYSES - 1} remaining analysis\n4️⃣ **Watch your score climb** — Most users improve 20-40 points on second try!\n\n📊 **Real results:** Average user goes from 52 → 78 after following our suggestions!\n\n🎯 **Goal:** Get to 75+ and watch interview invites roll in!`,
// //   },
// //   {
// //     keys: ["format","file","upload","pdf","word","docx","txt","supported","file type"],
// //     q: "📄 What file formats are supported?",
// //     a: `**Upload for analysis:**\n✅ Word (.docx) — Best for formatting\n✅ Paste plain text — Most reliable\n❌ PDF — Not yet supported (causes parsing issues)\n\n**Download formats:**\n✅ PDF — Print-ready\n✅ Word (.docx) — Editable\n✅ HTML — Web-friendly\n\n💡 **Pro tip:** Copy-paste from your PDF into the text area — it's faster and more accurate!`,
// //   },
// //   {
// //     keys: ["how long","time","fast","quick","seconds","minutes","speed","wait"],
// //     q: "⚡ How long does it take?",
// //     a: `**Lightning fast!** 🚀\n\n⏱️ **Analysis:** 15-30 seconds\n⏱️ **Resume generation:** 15-20 seconds\n⏱️ **Report download:** Instant\n\n**No waiting for emails — results appear instantly on screen!** \n\nCompare this to other services that take 5-10 minutes or hours by email. We value your time! ⏰`,
// //   },
// //   {
// //     keys: ["refund","money back","return","not satisfied","unhappy"],
// //     q: "💵 Can I get a refund?",
// //     a: `**We want you to be happy!** 😊\n\nSince results are delivered instantly (15-30 seconds), we generally don't offer refunds.\n\n**BUT** — if:\n❌ You had a technical issue\n❌ You didn't receive your results\n❌ Something clearly went wrong\n\n**Contact us immediately** and we'll make it right — whether that's a fix, credit, or refund. Your satisfaction matters! 💙\n\n📧 Reach out via the contact form below or email ${APP_EMAIL}`,
// //   },
// //   {
// //     keys: ["payment","credit card","stripe","visa","mastercard","amex","card","pay","declined"],
// //     q: "💳 What payment methods are accepted?",
// //     a: `**Secure payments via Stripe** 🔒\n\n✅ Visa\n✅ Mastercard  \n✅ American Express\n✅ Discover\n✅ Debit cards (with Visa/Mastercard logo)\n\n**Not accepted (yet):**\n❌ PayPal\n❌ Crypto\n❌ Bank transfer\n\n🔐 **Security:** Your card details never touch our servers — Stripe handles everything with bank-level encryption.\n\n💡 **Payment failed?** Double-check your details or try another card. Still stuck? Use the contact form below!`,
// //   },
// //   {
// //     keys: ["data","privacy","secure","safe","store","personal","gdpr","private","confidential"],
// //     q: "🔒 Is my data secure?",
// //     a: `**Your privacy is our priority!** 🛡️\n\n✅ **Firebase secure storage** — Encrypted at rest\n✅ **Never shared** — Zero third-party sharing\n✅ **Stripe payments** — Bank-level encryption\n✅ **No card storage** — We never see your card details\n✅ **GDPR compliant** — Full data control\n✅ **Delete anytime** — One-click account deletion\n\n📋 **What we store:**\n• Your resume text (for analysis)\n• Analysis results & scores\n• Generated resumes\n• Payment history\n\n❌ **What we DON'T store:**\n• Credit card info (Stripe handles this)\n• Passwords (encrypted via Firebase Auth)\n\n**Your data = YOUR data.** Period.`,
// //   },
// //   {
// //     keys: ["template","templates","designs","styles","choices","look","appearance"],
// //     q: "🎨 What templates are available?",
// //     a: `**${TMPL_COUNT} Professional ATS-Tested Templates** 🎨\n\n${templates.map((t, i) => `${i+1}. **${t.name}** — ${t.description}\n   ${t.tags?.map(tag => `🎯 ${tag}`).join(" · ")}`).join("\n\n")}\n\n✅ **All templates:**\n• Pass ATS scanners (tested with Workday, Greenhouse, Taleo)\n• Export to PDF/Word/HTML\n• Mobile-responsive\n• Recruiter-approved\n\n💡 **Which to choose?** Pick based on your industry! Finance/Law → Classic, Tech → Modern, Executive → Professional.`,
// //   },
// //   {
// //     keys: ["account","sign up","login","register","create","registration"],
// //     q: "📝 Do I need an account?",
// //     a: `**Yes, but it's quick and FREE!** 🎉\n\n⏱️ **Takes under 1 minute:**\n1️⃣ Name (first + last)\n2️⃣ Email address\n3️⃣ Password\n\n**Why create an account?**\n✅ Store all your analyses & resumes\n✅ Access from any device\n✅ Track your progress over time\n✅ View payment history\n✅ One-click re-analysis\n\n🚀 **No credit card required for account creation** — only when you purchase!\n\n[Sign up now →](/signup)`,
// //   },
// //   {
// //     keys: ["support","help","contact","reach","email","problem","issue","stuck","broken"],
// //     q: "💬 How do I contact support?",
// //     a: `**We're real humans and we love helping!** 💙\n\n📬 **Ways to reach us:**\n\n1️⃣ **Right here in this chat** (fastest!) — Use the form below\n2️⃣ **Email:** ${APP_EMAIL}\n3️⃣ **Support page:** /support\n\n⏱️ **Response time:** ${SUPPORT_HR}\n\n**What to include for faster help:**\n• Your email address\n• Description of the issue\n• Screenshot (if relevant)\n\n**No bots, no automated responses — just real people who want you to succeed!** 🎯`,
// //   },
// //   {
// //     keys: ["which plan","best plan","recommend","suggest","which one","choose","selection"],
// //     q: "🎯 Which plan should I choose?",
// //     a: `**Great question! Here's my recommendation:** 💪\n\n🔍 **For most job seekers (90% of users):**\n→ **ATS Basic (${PRICE})**\n→ ${ANALYSES} analyses + ${RESUME_GEN} resume\n→ Perfect for 1-3 job applications\n\n📊 **For heavy job seekers:**\n→ **Buy ATS Basic multiple times**\n→ Each purchase is independent\n→ ${ANALYSES} more analyses each time\n\n📄 **For document analysis (coming soon):**\n→ **Document Pro**\n→ Best for students, researchers, analysts\n\n💡 **Pro tip:** Start with ATS Basic. If you need more, just purchase again! No lock-in, no subscription.`,
// //   },
// //   {
// //     keys: ["forgot password","reset password","locked out","can't login","login problem","password reset"],
// //     q: "🔑 I forgot my password",
// //     a: `**No worries — happens to everyone!** 🔐\n\n📧 **Reset in 3 steps:**\n\n1️⃣ Click "Forgot Password" on login page\n2️⃣ Enter your email address\n3️⃣ Check your inbox (and **spam folder**!)\n\n⏱️ **Link expires in 1 hour** — so reset right away!\n\n❌ **Still locked out?** \n• Try a different browser\n• Clear your cache\n• Use the contact form below\n\n💡 **Pro tip:** Use a password manager like LastPass or Bitwarden to never forget again!`,
// //   },
// //   {
// //     keys: ["delete account","remove data","cancel account","close account","erase"],
// //     q: "🗑️ How do I delete my account?",
// //     a: `**We're sad to see you go, but respect your choice!** 💙\n\n📋 **Steps to delete:**\n\n1️⃣ Go to Account Settings\n2️⃣ Scroll to "Danger Zone"\n3️⃣ Click "Delete Account"\n4️⃣ Confirm your choice\n\n⏱️ **What happens:**\n• All analyses permanently deleted within 24 hours\n• All resumes removed\n• Personal data erased\n• Payment records anonymized (legal requirement)\n\n❌ **No take-backs** — this is permanent!\n\n💬 **Want to talk first?** Use the form below — we'd love to help before you go!`,
// //   },
// //   {
// //     keys: ["change email","update profile","edit account","change name","modify"],
// //     q: "✏️ Can I change my email or name?",
// //     a: `**Absolutely!** Any time, no questions asked. ✅\n\n📝 **How to update:**\n\n1️⃣ Go to Account Settings\n2️⃣ Click "Profile" tab\n3️⃣ Edit your information\n4️⃣ Save changes\n\n**What you can update:**\n✅ First & last name\n✅ Email address  \n✅ Password\n\n⏱️ **Changes take effect immediately**\n\n🔐 **Email change requires verification** — we'll send a confirmation link to your new address.\n\n💡 **Pro tip:** Keep your email updated so you never miss analysis results!`,
// //   },
// //   {
// //     keys: ["customize template","edit template","modify design","custom colors","change template"],
// //     q: "🎨 Can I customize the templates?",
// //     a: `**Currently:** Choose from ${TMPL_COUNT} pre-designed ATS-tested templates 🎨\n\nEach template has unique:\n• Color schemes\n• Layout structures  \n• Typography\n• Industry focus\n\n**Customization on our roadmap:** 🚧\n\n✅ **Coming soon:**\n• Upload your logo\n• Custom brand colors\n• Rearrange sections\n• Add/remove sections\n\n💡 **Want specific features?** Use the form below to vote on what you'd like to see! Your feedback shapes our roadmap.`,
// //   },
// //   {
// //     keys: ["better than","vs","compared to","competitor","alternative","other tools","jobscan","resumeworded","enhancv"],
// //     q: "🏆 How do you compare to other services?",
// //     a: `**Why ${APP_NAME} users love us:** 💙\n\n| Feature | Us | Others |\n|---------|----|----|\n| **Price** | ${PRICE} one-time | $20-50/month |\n| **Subscription** | ❌ Never | ✅ Always |\n| **Analyses** | ${ANALYSES} included | 1-2/month |\n| **Resumes** | ${RESUME_GEN} included | Extra $10+ |\n| **Templates** | ${TMPL_COUNT} free | 1-2 free |\n| **Uses YOUR data** | ✅ Yes | ❌ Generic |\n| **Instant results** | ✅ 30 seconds | ❌ 5-10 min |\n\n**The bottom line:** Better value, no lock-in, and results you can actually use! 🎯`,
// //   },
// //   {
// //     keys: ["does it work","real results","success","worked","interview","got job","proof","testimonials"],
// //     q: "📊 Does this actually work?",
// //     a: `**YES — and here's the proof!** 📈\n\n🎯 **The problem:** 75% of resumes are rejected by ATS before a human sees them\n\n✅ **The solution:** Our analysis shows you exactly what's missing and fixes it\n\n📊 **Real user results:**\n• "Score went from 45 → 82 after following suggestions!"\n• "Got 3 interviews in 2 weeks after using this!"\n• "Landing interviews I never thought possible"\n• "Best $${PRICE.replace('$', '')} I ever spent"\n\n🔬 **How it works:**\n1. Identify missing keywords\n2. AI injects them naturally\n3. ATS score increases\n4. Recruiters actually see your resume\n\n💪 **Your resume is your first impression — make it count!**`,
// //   },
// //   {
// //     keys: ["coming soon","future","new features","roadmap","what's next","planned"],
// //     q: "🚀 What's coming next?",
// //     a: `**Exciting things on the horizon!** 🌟\n\n🔜 **Imminent (Next 30 days):**\n• **Document Pro launch** — AI summaries + chat for any document\n• 3 more resume templates\n\n📅 **On our roadmap:**\n• 📝 **Cover letter generator** — Tailored to each job\n• 💼 **LinkedIn profile optimizer** — Match your resume\n• 📊 **Industry benchmarks** — Compare to others in your field\n• 🤖 **Bulk apply tool** — Optimize for multiple jobs at once\n\n🗳️ **Want to vote on features?** Use the contact form below and tell us what you'd love to see!\n\n📧 **Join the waitlist for Document Pro** — Be first to know when it launches!`,
// //   },
// //   {
// //     keys: ["hello","hi","hey","greetings","good morning","good afternoon","good evening","howdy","hola"],
// //     q: "👋 Hello!",
// //     a: `**Hey there! Welcome to ${APP_NAME}!** 🎉\n\nI'm your AI assistant, here to help with:\n• 💰 Pricing & plans\n• 🎨 Templates & design\n• 📊 ATS scoring\n• 🔧 Technical support\n\n**Quick question for you:** Are you actively job searching, or just exploring? Either way, I've got answers!\n\n💡 **Try asking:** "How much does it cost?" or "What templates are available?"\n\nWhat can I help you with today? 😊`,
// //   },
// //   {
// //     keys: ["thanks","thank you","appreciate","grateful","thx","cheers","awesome","great help"],
// //     q: "🙏 Thank you!",
// //     a: `**You're so welcome!** 💙\n\nThat's what we're here for — to help you land your dream job!\n\n🚀 **Ready to get started?**\n→ Head to the Dashboard\n→ Upload your resume\n→ Get your ATS score in 30 seconds\n\n📧 **Have more questions?** Just ask anytime! This chat saves your history.\n\n**Good luck with your job search — you've got this!** 💪✨\n\nP.S. Share us with a friend who's job hunting! 🎁`,
// //   },
// //   {
// //     keys: ["good","awesome","great","nice","cool","love it","amazing","fantastic","wonderful"],
// //     q: "😊 That's great!",
// //     a: `**So glad to hear it!** 🎉\n\n💡 **Here's what to do next:**\n\n1️⃣ **Create a free account** (if you haven't already)\n2️⃣ **Upload your resume** — paste or upload .docx\n3️⃣ **Paste a job description** — from any job board\n4️⃣ **Get your ATS score** — plus missing keywords\n5️⃣ **Generate your improved resume** — pick a template!\n\n⏱️ **Total time:** Under 5 minutes\n\n**Still have questions?** Just ask! I'm here 24/7. 🚀\n\n**Ready to transform your job search?** [Go to Dashboard →](/dashboard)`,
// //   },
// //   {
// //     keys: ["error","broken","not working","bug","failed","crash","problem","issue","glitch"],
// //     q: "🐛 Something isn't working",
// //     a: `**Oh no! Let's fix this together!** 🔧\n\n📋 **Quick troubleshooting:**\n\n1️⃣ **Refresh the page** — Solves 50% of issues\n2️⃣ **Clear browser cache** — Ctrl+Shift+Delete (Cmd+Shift+Delete on Mac)\n3️⃣ **Try a different browser** — Chrome/Firefox work best\n4️⃣ **Disable extensions** — Ad blockers sometimes interfere\n\n❌ **Still stuck?** Use the contact form below and include:\n• What happened (step by step)\n• Any error messages\n• Your browser/device\n• Screenshot if possible\n\n⏱️ **We'll respond within ${SUPPORT_HR}** and personally fix your issue!\n\n**We don't rest until you're happy!** 💙`,
// //   },
// //   {
// //     keys: ["resume score","ats score calculation","how score calculated","score meaning"],
// //     q: "📊 How is my ATS score calculated?",
// //     a: `**Our scoring algorithm analyzes 5 key factors:** 🎯\n\n1️⃣ **Keyword Match (40%)** — How many job description keywords appear in your resume\n\n2️⃣ **Formatting (20%)** — ATS-friendly layout, no tables/columns/images\n\n3️⃣ **Section Labels (15%)** — Standard headers (Work Experience, Education, Skills)\n\n4️⃣ **Bullet Points (15%)** — Action verbs, quantifiable achievements, relevant keywords\n\n5️⃣ **File Format (10%)** — .docx or plain text (PDF penalized)\n\n**Score interpretation:**\n• 90-100: Excellent — Recruiters will definitely see you\n• 75-89: Good — Minor tweaks needed\n• 60-74: Average — Missing important keywords\n• Below 60: Poor — Major overhaul needed\n\n🎯 **Goal:** 75+ to get past most ATS filters!`,
// //   },
// // ];

// // // Enhanced quick questions with emojis and better categorization
// // const QUICK_QUESTIONS = [
// //   { text: "💰 How much does it cost?", category: "pricing" },
// //   { text: "📦 What's included?", category: "features" },
// //   { text: "✨ How does resume generation work?", category: "features" },
// //   { text: "🎨 What templates are available?", category: "templates" },
// //   { text: "📈 How do I improve my score?", category: "help" },
// //   { text: "🔒 Is my data secure?", category: "security" },
// //   { text: "💬 How do I contact support?", category: "support" },
// //   { text: "🎯 Which plan should I choose?", category: "pricing" },
// //   { text: "💵 Can I get a refund?", category: "support" },
// //   { text: "📊 Does this actually work?", category: "testimonials" },
// //   { text: "🚀 What's coming next?", category: "roadmap" },
// //   { text: "🔑 Forgot password?", category: "account" },
// // ];

// // function matchFAQ(msg) {
// //   const lower = msg.toLowerCase();
// //   let best = null;
// //   let score = 0;
  
// //   for (const f of FAQ) {
// //     const s = f.keys.filter(k => lower.includes(k)).length;
// //     // Boost score for exact matches or question similarity
// //     const exactBonus = lower.includes(f.q.toLowerCase()) ? 2 : 0;
// //     const totalScore = s + exactBonus;
    
// //     if (totalScore > score) { 
// //       score = totalScore; 
// //       best = f; 
// //     }
// //   }
  
// //   return score > 0 ? best : null;
// // }

// // export default function ChatWidget() {
// //   const [open, setOpen] = useState(false);
// //   const [msgs, setMsgs] = useState([]);
// //   const [input, setInput] = useState("");
// //   const [stage, setStage] = useState("chat");
// //   const [pendingQ, setPendingQ] = useState("");
// //   const [name, setName] = useState("");
// //   const [email, setEmail] = useState("");
// //   const [formErr, setFormErr] = useState("");
// //   const [unread, setUnread] = useState(1);
// //   const [typing, setTyping] = useState(false);
// //   const [feedbackGiven, setFeedbackGiven] = useState(false);
// //   const bottomRef = useRef();
// //   const inputRef = useRef();

// //   useEffect(() => {
// //     bottomRef.current?.scrollIntoView({ behavior: "smooth" });
// //   }, [msgs, stage, typing]);

// //   useEffect(() => {
// //     if (open) {
// //       setUnread(0);
// //       if (msgs.length === 0) {
// //         const welcomeMessages = [
// //           `👋 Hi! I'm ${APP_NAME}'s assistant. Ask me anything about pricing, features, templates, or how to land more interviews!\n\n💡 **Try asking:** "How much does it cost?" or "What's included?"`,
// //           `🎯 Ready to supercharge your resume? I'm here to help! Ask about ATS scoring, resume templates, or how to improve your score.\n\n📊 **Quick question:** Are you actively job searching?`,
// //           `🌟 Welcome to ${APP_NAME}! Got questions? I've got answers — pricing, features, templates, technical support, you name it!\n\n💬 **Popular questions:** How does ATS scoring work? What templates are available?`,
// //         ];
// //         const randomWelcome = welcomeMessages[Math.floor(Math.random() * welcomeMessages.length)];
// //         setMsgs([{ from: "bot", text: randomWelcome, timestamp: new Date() }]);
// //       }
// //       setTimeout(() => inputRef.current?.focus(), 100);
// //     }
// //   }, [open, msgs.length]);

// //   function addMsg(from, text) {
// //     setMsgs(prev => [...prev, { from, text, timestamp: new Date() }]);
// //   }

// //   async function send(text) {
// //     const msg = (text || input).trim();
// //     if (!msg) return;
    
// //     setInput("");
// //     addMsg("user", msg);
// //     setTyping(true);

// //     setTimeout(() => {
// //       setTyping(false);
// //       const match = matchFAQ(msg);
      
// //       if (match) {
// //         addMsg("bot", match.a);
        
// //         // Ask for feedback after helpful response (but not too often)
// //         if (!feedbackGiven && msgs.length > 3 && Math.random() > 0.7) {
// //           setTimeout(() => {
// //             addMsg("bot", "💙 **Was that helpful?**\n\n• If yes — great! Anything else I can help with?\n• If no — use the form below and a human will personally assist you!");
// //             setFeedbackGiven(true);
// //           }, 1500);
// //         }
// //       } else {
// //         setPendingQ(msg);
// //         addMsg("bot", `🤔 **Great question!** I want to make sure you get the best possible answer.\n\n📬 **Leave your name and email below** — our support team will personally respond within ${SUPPORT_HR} with a detailed answer.\n\n💡 **Or try rephrasing your question** — I might have an answer!`);
// //         setStage("collect");
// //       }
// //     }, 800);
// //   }

// //   async function submitContact(e) {
// //     e.preventDefault();
// //     setFormErr("");

// //     if (!name.trim()) {
// //       setFormErr("Please enter your name so we can address you personally! 📝");
// //       return;
// //     }
// //     if (!email.trim() || !email.includes("@") || !email.includes(".")) {
// //       setFormErr("Please enter a valid email address so we can reach you! 📧");
// //       return;
// //     }
// //     if (!pendingQ.trim()) {
// //       setFormErr("No question to send — please type your question first. 💬");
// //       return;
// //     }

// //     setStage("sending");

// //     try {
// //       const res = await fetch(`${BACKEND_URL}/email/support`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({
// //           firstName: name.split(" ")[0].trim(),
// //           lastName: name.split(" ").slice(1).join(" ").trim() || "",
// //           email: email.trim(),
// //           topic: "Chat Widget Support Question",
// //           message: `Question: ${pendingQ}\n\nName: ${name}\nEmail: ${email}\nUser Agent: ${navigator.userAgent}`,
// //           userId: "chat_widget",
// //         }),
// //       });

// //       if (!res.ok) throw new Error(`Server returned ${res.status}`);

// //       setStage("sent");
// //       addMsg("bot", `✅ **Perfect ${name.split(" ")[0]}!** We've received your question and will reply to **${email}** within ${SUPPORT_HR}.\n\n📬 **Check your spam folder** just in case!\n\n💬 **Anything else I can help with in the meantime?**`);
// //       setName("");
// //       setEmail("");
// //       setPendingQ("");

// //     } catch (err) {
// //       console.error("ChatWidget email error:", err);
// //       setStage("error");
// //       setFormErr(`⚠️ Couldn't send your message. Please email us directly at ${APP_EMAIL} with your question.`);
// //     }
// //   }

// //   const fieldStyle = {
// //     padding: "10px 13px",
// //     border: "1.5px solid #e2e8f0",
// //     borderRadius: 10,
// //     fontSize: 13,
// //     outline: "none",
// //     fontFamily: "inherit",
// //     width: "100%",
// //     boxSizing: "border-box",
// //     background: "#fafafa",
// //     transition: "all 0.2s",
// //   };

// //   return (
// //     <>
// //       {/* Floating Button */}
// //       <button
// //         onClick={() => setOpen(o => !o)}
// //         aria-label="Open support chat"
// //         style={{
// //           position: "fixed", bottom: 24, right: 24, zIndex: 9999,
// //           width: 56, height: 56, borderRadius: "50%",
// //           background: open ? "#374151" : "linear-gradient(135deg,#2563eb,#1d4ed8)",
// //           border: "none", cursor: "pointer",
// //           display: "flex", alignItems: "center", justifyContent: "center",
// //           boxShadow: "0 8px 28px rgba(37,99,235,0.35)",
// //           transition: "all 0.25s",
// //         }}
// //         onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.08)"; e.currentTarget.style.boxShadow = "0 12px 32px rgba(37,99,235,0.45)"; }}
// //         onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0 8px 28px rgba(37,99,235,0.35)"; }}
// //       >
// //         {open ? (
// //           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
// //             <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
// //           </svg>
// //         ) : (
// //           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //             <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
// //           </svg>
// //         )}
// //         {!open && unread > 0 && (
// //           <span style={{
// //             position: "absolute", top: -4, right: -4,
// //             width: 20, height: 20, borderRadius: "50%",
// //             background: "#ef4444", color: "#fff",
// //             fontSize: 10, fontWeight: 800,
// //             display: "flex", alignItems: "center", justifyContent: "center",
// //             border: "2px solid #fff",
// //           }}>{unread}</span>
// //         )}
// //       </button>

// //       {/* Chat Window */}
// //       {open && (
// //         <div style={{
// //           position: "fixed", bottom: 92, right: 24, zIndex: 9998,
// //           width: 400, maxWidth: "calc(100vw - 32px)",
// //           height: 620, maxHeight: "calc(100vh - 110px)",
// //           background: "#fff", borderRadius: 20,
// //           boxShadow: "0 25px 60px rgba(0,0,0,0.2)",
// //           display: "flex", flexDirection: "column",
// //           overflow: "hidden",
// //           fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
// //           animation: "slideUp 0.3s ease",
// //         }}>
// //           <style>{`
// //             @keyframes slideUp {
// //               from { opacity: 0; transform: translateY(20px); }
// //               to { opacity: 1; transform: translateY(0); }
// //             }
// //             @keyframes pulse {
// //               0%, 100% { opacity: 1; }
// //               50% { opacity: 0.5; }
// //             }
// //             @keyframes bounce {
// //               0%, 100% { transform: translateY(0); }
// //               50% { transform: translateY(-3px); }
// //             }
// //             .msg-animation {
// //               animation: slideUp 0.2s ease;
// //             }
// //             .typing-dot {
// //               display: inline-block;
// //               width: 8px;
// //               height: 8px;
// //               border-radius: 50%;
// //               background: #94a3b8;
// //               margin: 0 2px;
// //               animation: pulse 1.4s infinite;
// //             }
// //             .typing-dot:nth-child(2) { animation-delay: 0.2s; }
// //             .typing-dot:nth-child(3) { animation-delay: 0.4s; }
// //           `}</style>

// //           {/* Header */}
// //           <div style={{ background: "linear-gradient(135deg,#0f172a,#1e293b)", padding: "16px 18px", display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
// //             <div style={{ width: 40, height: 40, borderRadius: "50%", background: "linear-gradient(135deg,#2563eb,#1d4ed8)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
// //               <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// //                 <circle cx="12" cy="12" r="10"/>
// //                 <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
// //                 <line x1="12" y1="17" x2="12.01" y2="17"/>
// //               </svg>
// //             </div>
// //             <div style={{ flex: 1 }}>
// //               <div style={{ fontWeight: 700, fontSize: 15, color: "#fff", letterSpacing: "-0.3px" }}>
// //                 {APP_NAME} Support
// //               </div>
// //               <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 3 }}>
// //                 <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#22c55e", display: "inline-block", animation: "pulse 2s infinite" }}/>
// //                 <span style={{ fontSize: 11, color: "rgba(255,255,255,0.6)" }}>
// //                   Online · Usually replies in seconds
// //                 </span>
// //               </div>
// //             </div>
// //             <button 
// //               onClick={() => setOpen(false)}
// //               style={{ 
// //                 background: "rgba(255,255,255,0.1)", 
// //                 border: "none", 
// //                 color: "rgba(255,255,255,0.6)", 
// //                 cursor: "pointer", 
// //                 padding: "6px 8px", 
// //                 borderRadius: 8, 
// //                 display: "flex",
// //                 transition: "all 0.2s",
// //               }}
// //               onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.2)"}
// //               onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
// //             >
// //               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
// //                 <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
// //               </svg>
// //             </button>
// //           </div>

// //           {/* Messages Area */}
// //           <div style={{ flex: 1, overflowY: "auto", padding: "16px", display: "flex", flexDirection: "column", gap: 12, background: "#f8fafc" }}>
// //             {msgs.map((m, i) => (
// //               <div key={i} className="msg-animation" style={{ display: "flex", justifyContent: m.from === "user" ? "flex-end" : "flex-start" }}>
// //                 <div style={{
// //                   maxWidth: "85%", 
// //                   padding: "10px 14px",
// //                   borderRadius: m.from === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
// //                   background: m.from === "user" ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "#fff",
// //                   color: m.from === "user" ? "#fff" : "#1e293b",
// //                   fontSize: 13, 
// //                   lineHeight: 1.65,
// //                   boxShadow: m.from === "bot" ? "0 2px 8px rgba(0,0,0,0.06)" : "0 2px 8px rgba(37,99,235,0.2)",
// //                   border: m.from === "bot" ? "1px solid #e2e8f0" : "none",
// //                   whiteSpace: "pre-line",
// //                 }}>
// //                   {m.text.split('\n').map((line, idx) => (
// //                     <span key={idx}>
// //                       {line}
// //                       {idx < m.text.split('\n').length - 1 && <br />}
// //                     </span>
// //                   ))}
// //                 </div>
// //               </div>
// //             ))}
            
// //             {typing && (
// //               <div className="msg-animation" style={{ display: "flex", justifyContent: "flex-start" }}>
// //                 <div style={{ background: "#fff", padding: "12px 16px", borderRadius: "18px", border: "1px solid #e2e8f0", display: "flex", gap: 4, alignItems: "center" }}>
// //                   <span className="typing-dot" />
// //                   <span className="typing-dot" />
// //                   <span className="typing-dot" />
// //                 </div>
// //               </div>
// //             )}

// //             {/* Contact Form */}
// //             {(stage === "collect" || stage === "error") && (
// //               <div className="msg-animation" style={{ background: "#fff", borderRadius: 16, padding: "16px", border: "2px solid #bfdbfe", marginTop: 4 }}>
// //                 <div style={{ fontSize: 13, fontWeight: 600, color: "#1e40af", marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
// //                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //                     <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
// //                     <polyline points="22,6 12,13 2,6"/>
// //                   </svg>
// //                   <span>We'll reply within {SUPPORT_HR}</span>
// //                 </div>
// //                 <form onSubmit={submitContact} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
// //                   <input
// //                     style={fieldStyle}
// //                     placeholder="Your full name *"
// //                     value={name}
// //                     onChange={e => setName(e.target.value)}
// //                     onFocus={e => { e.target.style.borderColor = "#3b82f6"; e.target.style.background = "#fff"; }}
// //                     onBlur={e => { e.target.style.borderColor = "#e2e8f0"; e.target.style.background = "#fafafa"; }}
// //                   />
// //                   <input
// //                     style={fieldStyle}
// //                     type="email"
// //                     placeholder="Your email address *"
// //                     value={email}
// //                     onChange={e => setEmail(e.target.value)}
// //                     onFocus={e => { e.target.style.borderColor = "#3b82f6"; e.target.style.background = "#fff"; }}
// //                     onBlur={e => { e.target.style.borderColor = "#e2e8f0"; e.target.style.background = "#fafafa"; }}
// //                   />
// //                   {pendingQ && (
// //                     <div style={{ fontSize: 11, color: "#475569", background: "#f1f5f9", borderRadius: 8, padding: "8px 10px", border: "1px solid #e2e8f0" }}>
// //                       <span style={{ fontWeight: 600 }}>Your question:</span> {pendingQ}
// //                     </div>
// //                   )}
// //                   {formErr && (
// //                     <div style={{ fontSize: 12, color: "#dc2626", background: "#fef2f2", borderRadius: 8, padding: "8px 10px", border: "1px solid #fecaca" }}>
// //                       {formErr}
// //                     </div>
// //                   )}
// //                   <button 
// //                     type="submit"
// //                     style={{ 
// //                       padding: "11px", 
// //                       background: "linear-gradient(135deg,#2563eb,#1d4ed8)", 
// //                       color: "#fff", 
// //                       border: "none", 
// //                       borderRadius: 10, 
// //                       fontWeight: 700, 
// //                       fontSize: 13, 
// //                       cursor: "pointer", 
// //                       fontFamily: "inherit",
// //                       transition: "all 0.2s",
// //                     }}
// //                     onMouseEnter={e => e.currentTarget.style.transform = "translateY(-1px)"}
// //                     onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
// //                   >
// //                     Send Question →
// //                   </button>
// //                   <button 
// //                     type="button" 
// //                     onClick={() => { setStage("chat"); setPendingQ(""); setFormErr(""); }}
// //                     style={{ padding: "5px", background: "transparent", color: "#94a3b8", border: "none", fontSize: 11, cursor: "pointer", fontFamily: "inherit", textDecoration: "underline" }}
// //                   >
// //                     Skip — ask something else
// //                   </button>
// //                 </form>
// //               </div>
// //             )}

// //             {stage === "sending" && (
// //               <div className="msg-animation" style={{ textAlign: "center", color: "#64748b", fontSize: 13, padding: "12px", background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
// //                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ animation: "pulse 1s infinite" }}>
// //                   <line x1="22" y1="2" x2="11" y2="13"/>
// //                   <polygon points="22 2 15 22 11 13 2 9 22 2"/>
// //                 </svg>
// //                 Sending your question...
// //               </div>
// //             )}

// //             <div ref={bottomRef} />
// //           </div>

// //           {/* Quick Questions */}
// //           {msgs.length <= 2 && stage === "chat" && (
// //             <div style={{ padding: "12px", borderTop: "1px solid #e2e8f0", background: "#fff", flexShrink: 0 }}>
// //               <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>
// //                 💡 Popular Questions
// //               </div>
// //               <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
// //                 {QUICK_QUESTIONS.map(q => (
// //                   <button 
// //                     key={q.text} 
// //                     onClick={() => send(q.text)}
// //                     style={{ 
// //                       fontSize: 11, 
// //                       padding: "5px 12px", 
// //                       borderRadius: 20, 
// //                       background: "#eff6ff", 
// //                       color: "#2563eb", 
// //                       border: "1px solid #bfdbfe", 
// //                       cursor: "pointer", 
// //                       fontFamily: "inherit", 
// //                       fontWeight: 500,
// //                       transition: "all 0.2s",
// //                       whiteSpace: "nowrap",
// //                     }}
// //                     onMouseEnter={e => { e.currentTarget.style.background = "#dbeafe"; e.currentTarget.style.transform = "translateY(-1px)"; }}
// //                     onMouseLeave={e => { e.currentTarget.style.background = "#eff6ff"; e.currentTarget.style.transform = "translateY(0)"; }}
// //                   >
// //                     {q.text}
// //                   </button>
// //                 ))}
// //               </div>
// //             </div>
// //           )}

// //           {/* Input Area */}
// //           {(stage === "chat" || stage === "sent") && (
// //             <div style={{ padding: "12px", borderTop: "1px solid #e2e8f0", background: "#fff", display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
// //               <input
// //                 ref={inputRef}
// //                 value={input}
// //                 onChange={e => setInput(e.target.value)}
// //                 onKeyDown={e => e.key === "Enter" && !e.shiftKey && send()}
// //                 placeholder="Type your question... 💬"
// //                 style={{ 
// //                   flex: 1, 
// //                   padding: "10px 14px", 
// //                   border: "1.5px solid #e2e8f0", 
// //                   borderRadius: 24, 
// //                   fontSize: 13, 
// //                   outline: "none", 
// //                   fontFamily: "inherit", 
// //                   background: "#f8fafc",
// //                   transition: "all 0.2s",
// //                 }}
// //                 onFocus={e => { e.target.style.borderColor = "#3b82f6"; e.target.style.background = "#fff"; }}
// //                 onBlur={e => { e.target.style.borderColor = "#e2e8f0"; e.target.style.background = "#f8fafc"; }}
// //               />
// //               <button 
// //                 onClick={() => send()}
// //                 disabled={!input.trim()}
// //                 style={{ 
// //                   width: 38, 
// //                   height: 38, 
// //                   borderRadius: "50%", 
// //                   background: input.trim() ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "#e2e8f0", 
// //                   border: "none", 
// //                   cursor: input.trim() ? "pointer" : "default", 
// //                   display: "flex", 
// //                   alignItems: "center", 
// //                   justifyContent: "center", 
// //                   flexShrink: 0,
// //                   transition: "all 0.2s",
// //                 }}
// //                 onMouseEnter={e => { if (input.trim()) e.currentTarget.style.transform = "scale(1.05)"; }}
// //                 onMouseLeave={e => { if (input.trim()) e.currentTarget.style.transform = "scale(1)"; }}
// //               >
// //                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={input.trim() ? "#fff" : "#94a3b8"} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
// //                   <line x1="22" y1="2" x2="11" y2="13"/>
// //                   <polygon points="22 2 15 22 11 13 2 9 22 2"/>
// //                 </svg>
// //               </button>
// //             </div>
// //           )}

// //           {/* Footer */}
// //           <div style={{ padding: "6px 12px 8px", background: "#fff", textAlign: "center", flexShrink: 0, borderTop: "1px solid #f8fafc" }}>
// //             <span style={{ fontSize: 10, color: "#cbd5e1" }}>{APP_NAME} · </span>
// //             <a href="/support" style={{ fontSize: 10, color: "#94a3b8", textDecoration: "none" }}
// //               onMouseEnter={e => e.target.style.color = "#2563eb"}
// //               onMouseLeave={e => e.target.style.color = "#94a3b8"}>
// //               Full support page →
// //             </a>
// //           </div>
// //         </div>
// //       )}
// //     </>
// //   );
// // }

// // src/components/ChatWidget.jsx
// // FAQ answers are built from servicesConfig so they stay in sync with pricing/branding.
// // Unknown questions collect name+email and POST to /email/support on the backend.

// import { useState, useEffect, useRef } from "react";
// import servicesConfig from "../utils/servicesConfig";

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";

// // ── Pull live values from config so FAQ never goes stale ──
// const cfg        = servicesConfig.app;
// const basicPlan  = servicesConfig.plans.find(p => p.id === "ats_basic");
// const docPlan    = servicesConfig.plans.find(p => p.id === "doc_pro");
// const templates  = servicesConfig.resumeTemplates.filter(t => t.active && !t.comingSoon);
// const PRICE      = basicPlan?.price        || "$2.99";
// const ANALYSES   = basicPlan?.analysisCount || 2;
// const RESUME_GEN = basicPlan?.resumeGenCount || 1;
// const TMPL_COUNT = templates.length;
// const SUPPORT_HR = cfg.supportHours        || "2-4 hours";
// const APP_NAME   = cfg.name                || "ResumeScoreAI";
// const APP_EMAIL  = cfg.email               || "support@smartaicareer.com";

// // ── FAQ with clean, simple responses (no special characters that cause formatting issues) ──
// const FAQ = [
//   {
//     keys: ["price","cost","how much","fee","charge","dollar","$","pricing"],
//     q: "💰 How much does it cost?",
//     a: `Great question! ${APP_NAME} is just ${PRICE} — a one-time payment, no subscription ever.

// What you get:
// • ${ANALYSES} full ATS analyses
// • ${RESUME_GEN} AI-improved resume
// • ${TMPL_COUNT} professional templates
// • Instant results

// That's less than a coffee! ☕`,
//   },
//   {
//     keys: ["subscription","monthly","recurring","cancel","automatic","renew","billing"],
//     q: "🔄 Is there a subscription?",
//     a: `No subscriptions — EVER! 🙌

// ✅ One-time payment only
// ✅ No hidden fees
// ✅ No automatic renewals
// ✅ Keep what you buy forever

// Pay once, use your credits, and that's it. Simple and fair. 💙`,
//   },
//   {
//     keys: ["document pro","doc pro","second plan","upgrade","document summary"],
//     q: "📊 What about Document Pro?",
//     a: docPlan && docPlan.active
//       ? `Document Pro is ${docPlan.price} one-time! 🚀

// Includes:
// • ${docPlan.analysisCount || 3} ATS analyses
// • AI document summarization with charts
// • Document chat Q&A
// • ${RESUME_GEN} AI resume

// Perfect for analyzing reports, research papers, or long documents!`
//       : `Document Pro (coming soon! 🎉) will include:
// • AI document summarization with visual charts
// • Interactive document chat/Q&A
// • ${ANALYSES * 2} ATS analyses

// Want early access? Use the contact form below and we'll notify you when it launches!`,
//   },
//   {
//     keys: ["ats","applicant tracking","ats score","what is ats","how ats works"],
//     q: "🎯 What is an ATS score and why does it matter?",
//     a: `ATS = Applicant Tracking System (software companies use to filter resumes).

// Your ATS Score (0-100) measures how well your resume matches a job description.

// 75% of resumes are rejected by ATS before a human sees them.

// ATS Score Standards:
// 95-100: Exceptional - Recruiters will definitely see you
// 90-94: Strong - You meet recruiter attention thresholds
// 85-89: Good - You'll pass most ATS filters
// 75-84: Fair - Borderline, some ATS will filter you
// 60-74: Below Average - High risk of being filtered
// Below 60: Poor - Most ATS systems reject automatically

// Your goal: Reach 85+ to get interviews!`,
//   },
//   {
//     keys: ["ats standards","ats score meaning","score interpretation","what does ats score mean","score guide","score range","score ranges"],
//     q: "📊 What do the ATS score ranges mean?",
//     a: `ATS Score Standards:

// 95-100 (Exceptional - Top of Pile)
// - Recruiters will definitely see your resume
// - You rank in the top tier of applicants

// 90-94 (Strong - Recruiter Ready)
// - Your resume meets recruiter attention thresholds
// - You're in the top 15% of applicants

// 85-89 (Good - Competitive)
// - Solid foundation, passes most ATS filters
// - Most users reach this after optimization

// 75-84 (Fair - Needs Minor Work)
// - Borderline - some ATS will filter you out
// - One round of improvements typically fixes this

// 60-74 (Below Average - Needs Improvement)
// - High risk of being filtered out
// - Don't apply until you improve this score

// Below 60 (Poor - High Rejection Risk)
// - Most ATS systems reject automatically
// - Complete overhaul recommended

// Industry Benchmarks:
// Tech / Software: 88+ to stand out
// Finance / Banking: 82+ to pass
// Healthcare: 80+ to be seen
// Marketing: 75+ to compete
// Legal: 85+ for top firms

// Your target: 85+ for interview invites!`,
//   },
//   {
//     keys: ["include","what do i get","features","what's included","package","included"],
//     q: "📦 What's included in ATS Basic?",
//     a: `ATS Basic (${PRICE}) includes everything you need:

// Analyses (${ANALYSES} total):
// - Full ATS score (0-100)
// - Keyword gap analysis
// - Section-by-section feedback
// - AI rewrite suggestions
// - Downloadable PDF report

// Resume Generation (${RESUME_GEN}):
// - AI-improved resume using YOUR real data
// - ${TMPL_COUNT} professional templates
// - PDF + Word + HTML download
// - ATS-optimized formatting

// Total value: ~$50 — you pay just ${PRICE}! 🎉`,
//   },
//   {
//     keys: ["resume","generate","generator","template","improved","ai resume","optimize"],
//     q: "✨ How does the AI resume generator work?",
//     a: `Magic happens in 3 steps:

// 1. Analysis - We scan your resume against the job description
// 2. Enhancement - AI injects missing keywords naturally into your real experience
// 3. Generation - You pick from ${TMPL_COUNT} beautiful templates and download instantly

// Takes 15-20 seconds - no generic filler, just your improved resume!

// Templates available: ${templates.map(t => t.name).join(", ")}`,
//   },
//   {
//     keys: ["multiple","2 analysis","two","analyze again","re-analyze","second analysis","more than one"],
//     q: "🔄 Can I run multiple analyses?",
//     a: `Absolutely! ATS Basic includes ${ANALYSES} full analyses per purchase.

// Pro tip - Multi-Job Strategy:
// 1. Run analysis with Job A
// 2. Run analysis with Job B
// 3. Compare both scores
// 4. Generate resume for the job with highest match

// Different jobs need different keywords. This strategy can increase interview chances by 3x!`,
//   },
//   {
//     keys: ["low score","bad score","improve","better score","increase score","fix resume"],
//     q: "📈 My score was low — how do I improve it?",
//     a: `Don't worry — that's why we're here!

// Step-by-step improvement plan:
// 1. Check "Missing Keywords" - These are the specific words employers want
// 2. Add them naturally - Integrate into your bullet points
// 3. Re-analyze - Use your remaining analysis
// 4. Watch your score climb - Most users improve 20-40 points!

// Real results: Average user goes from 52 to 78 after following our suggestions!

// Goal: Get to 85+ and watch interview invites roll in!`,
//   },
//   {
//     keys: ["format","file","upload","pdf","word","docx","txt","supported","file type"],
//     q: "📄 What file formats are supported?",
//     a: `Upload for analysis:
// - Word (.docx) - Best for formatting
// - Paste plain text - Most reliable
// - PDF - Not yet supported

// Download formats:
// - PDF - Print-ready
// - Word (.docx) - Editable
// - HTML - Web-friendly

// Pro tip: Copy-paste from your PDF into the text area - it's faster!`,
//   },
//   {
//     keys: ["how long","time","fast","quick","seconds","minutes","speed","wait"],
//     q: "⚡ How long does it take?",
//     a: `Lightning fast!

// - Analysis: 15-30 seconds
// - Resume generation: 15-20 seconds
// - Report download: Instant

// No waiting for emails — results appear instantly on screen!`,
//   },
//   {
//     keys: ["refund","money back","return","not satisfied","unhappy"],
//     q: "💵 Can I get a refund?",
//     a: `We want you to be happy!

// Since results are delivered instantly, we generally don't offer refunds.

// BUT if you had a technical issue or something went wrong, contact us immediately and we'll make it right.

// Your satisfaction matters!

// Reach out via the contact form below or email ${APP_EMAIL}`,
//   },
//   {
//     keys: ["payment","credit card","stripe","visa","mastercard","amex","card","pay","declined"],
//     q: "💳 What payment methods are accepted?",
//     a: `Secure payments via Stripe

// Accepted:
// - Visa, Mastercard, American Express, Discover
// - Debit cards with Visa/Mastercard logo

// Not accepted:
// - PayPal, Crypto, Bank transfer

// Security: Your card details never touch our servers — Stripe handles everything with bank-level encryption.`,
//   },
//   {
//     keys: ["data","privacy","secure","safe","store","personal","gdpr","private","confidential"],
//     q: "🔒 Is my data secure?",
//     a: `Your privacy is our priority!

// - Firebase secure storage - Encrypted at rest
// - Never shared - Zero third-party sharing
// - Stripe payments - Bank-level encryption
// - No card storage - We never see your card details
// - GDPR compliant - Full data control
// - Delete anytime - One-click account deletion

// Your data = YOUR data. Period.`,
//   },
//   {
//     keys: ["template","templates","designs","styles","choices","look","appearance"],
//     q: "🎨 What templates are available?",
//     a: `${TMPL_COUNT} Professional ATS-Tested Templates

// ${templates.map((t, i) => `${i+1}. ${t.name} - ${t.description}`).join("\n")}

// All templates:
// - Pass ATS scanners (Workday, Greenhouse, Taleo)
// - Export to PDF/Word/HTML
// - Mobile-responsive
// - Recruiter-approved

// Pick based on your industry! Finance/Law → Classic, Tech → Modern, Executive → Professional.`,
//   },
//   {
//     keys: ["account","sign up","login","register","create","registration"],
//     q: "📝 Do I need an account?",
//     a: `Yes, but it's quick and FREE!

// Takes under 1 minute:
// 1. Name (first + last)
// 2. Email address
// 3. Password

// Why create an account?
// - Store all your analyses and resumes
// - Access from any device
// - Track your progress over time
// - View payment history
// - One-click re-analysis

// No credit card required for account creation!`,
//   },
//   {
//     keys: ["support","help","contact","reach","email","problem","issue","stuck","broken"],
//     q: "💬 How do I contact support?",
//     a: `We're real humans and we love helping!

// Ways to reach us:
// 1. Right here in this chat (fastest!) - Use the form below
// 2. Email: ${APP_EMAIL}
// 3. Support page: /support

// Response time: ${SUPPORT_HR}

// No bots, no automated responses — just real people who want you to succeed!`,
//   },
//   {
//     keys: ["which plan","best plan","recommend","suggest","which one","choose","selection"],
//     q: "🎯 Which plan should I choose?",
//     a: `Great question! Here's my recommendation:

// For most job seekers (90% of users):
// - ATS Basic (${PRICE})
// - ${ANALYSES} analyses + ${RESUME_GEN} resume
// - Perfect for 1-3 job applications

// For heavy job seekers:
// - Buy ATS Basic multiple times
// - Each purchase is independent

// Pro tip: Start with ATS Basic. If you need more, just purchase again! No subscription.`,
//   },
//   {
//     keys: ["forgot password","reset password","locked out","can't login","login problem","password reset"],
//     q: "🔑 I forgot my password",
//     a: `No worries — happens to everyone!

// Reset in 3 steps:
// 1. Click "Forgot Password" on login page
// 2. Enter your email address
// 3. Check your inbox (and spam folder!)

// Link expires in 1 hour — so reset right away!

// Still locked out? Use the contact form below.`,
//   },
//   {
//     keys: ["delete account","remove data","cancel account","close account","erase"],
//     q: "🗑️ How do I delete my account?",
//     a: `We're sad to see you go, but respect your choice!

// Steps to delete:
// 1. Go to Account Settings
// 2. Scroll to "Danger Zone"
// 3. Click "Delete Account"
// 4. Confirm your choice

// All data permanently deleted within 24 hours.

// Want to talk first? Use the form below — we'd love to help before you go!`,
//   },
//   {
//     keys: ["change email","update profile","edit account","change name","modify"],
//     q: "✏️ Can I change my email or name?",
//     a: `Absolutely! Any time, no questions asked.

// How to update:
// 1. Go to Account Settings
// 2. Click "Profile" tab
// 3. Edit your information
// 4. Save changes

// What you can update:
// - First and last name
// - Email address
// - Password

// Changes take effect immediately!`,
//   },
//   {
//     keys: ["customize template","edit template","modify design","custom colors","change template"],
//     q: "🎨 Can I customize the templates?",
//     a: `Currently: Choose from ${TMPL_COUNT} pre-designed ATS-tested templates.

// Each template has unique color schemes, layouts, and typography.

// Customization coming soon:
// - Upload your logo
// - Custom brand colors
// - Rearrange sections

// Want specific features? Use the form below to vote!`,
//   },
//   {
//     keys: ["better than","vs","compared to","competitor","alternative","other tools","jobscan","resumeworded","enhancv"],
//     q: "🏆 How do you compare to other services?",
//     a: `Why ${APP_NAME} users love us:

// - Price: ${PRICE} one-time vs $20-50/month elsewhere
// - Subscription: Never vs Always
// - Analyses: ${ANALYSES} included vs 1-2/month
// - Resumes: ${RESUME_GEN} included vs Extra $10+
// - Templates: ${TMPL_COUNT} free vs 1-2 free
// - Uses YOUR data: Yes vs Generic filler
// - Instant results: 30 seconds vs 5-10 minutes

// Better value, no lock-in, and results you can actually use!`,
//   },
//   {
//     keys: ["does it work","real results","success","worked","interview","got job","proof","testimonials"],
//     q: "📊 Does this actually work?",
//     a: `YES — and here's the proof!

// The problem: 75% of resumes are rejected by ATS before a human sees them

// The solution: Our analysis shows you exactly what's missing and fixes it

// Real user results:
// - Score went from 45 to 82
// - Got 3 interviews in 2 weeks
// - Best $${PRICE.replace('$', '')} I ever spent

// How it works:
// 1. Identify missing keywords
// 2. AI injects them naturally
// 3. ATS score increases
// 4. Recruiters actually see your resume

// Your resume is your first impression — make it count!`,
//   },
//   {
//     keys: ["coming soon","future","new features","roadmap","what's next","planned"],
//     q: "🚀 What's coming next?",
//     a: `Exciting things on the horizon!

// Coming soon (Next 30 days):
// - Document Pro launch - AI summaries + chat for any document
// - 3 more resume templates

// On our roadmap:
// - Cover letter generator
// - LinkedIn profile optimizer
// - Industry benchmarks
// - Bulk apply tool

// Want to vote on features? Use the contact form below!`,
//   },
//   {
//     keys: ["hello","hi","hey","greetings","good morning","good afternoon","good evening","howdy","hola"],
//     q: "👋 Hello!",
//     a: `Hey there! Welcome to ${APP_NAME}!

// I'm your AI assistant, here to help with:
// - Pricing and plans
// - Templates and design
// - ATS scoring
// - Technical support

// Try asking: "How much does it cost?" or "What do the ATS score ranges mean?"

// What can I help you with today?`,
//   },
//   {
//     keys: ["thanks","thank you","appreciate","grateful","thx","cheers","awesome","great help"],
//     q: "🙏 Thank you!",
//     a: `You're so welcome!

// That's what we're here for — to help you land your dream job!

// Ready to get started?
// - Head to the Dashboard
// - Upload your resume
// - Get your ATS score in 30 seconds

// Good luck with your job search — you've got this!`,
//   },
//   {
//     keys: ["good","awesome","great","nice","cool","love it","amazing","fantastic","wonderful"],
//     q: "😊 That's great!",
//     a: `So glad to hear it!

// Here's what to do next:
// 1. Create a free account (if you haven't already)
// 2. Upload your resume - paste or upload .docx
// 3. Paste a job description - from any job board
// 4. Get your ATS score - plus missing keywords
// 5. Generate your improved resume - pick a template!

// Total time: Under 5 minutes

// Ready to transform your job search? Go to Dashboard!`,
//   },
//   {
//     keys: ["error","broken","not working","bug","failed","crash","problem","issue","glitch"],
//     q: "🐛 Something isn't working",
//     a: `Oh no! Let's fix this together!

// Quick troubleshooting:
// 1. Refresh the page - Solves 50% of issues
// 2. Clear browser cache
// 3. Try a different browser - Chrome/Firefox work best
// 4. Disable extensions - Ad blockers sometimes interfere

// Still stuck? Use the contact form below and include:
// - What happened
// - Any error messages
// - Your browser and device

// We'll respond within ${SUPPORT_HR} and personally fix your issue!`,
//   },
//   {
//     keys: ["resume score","ats score calculation","how score calculated","score meaning","score calculation"],
//     q: "📊 How is my ATS score calculated?",
//     a: `Our scoring algorithm analyzes 5 key factors:

// 1. Keyword Match (40%) - JD keywords in your resume
// 2. Formatting (20%) - ATS-friendly layout
// 3. Section Labels (15%) - Standard headers
// 4. Bullet Points (15%) - Action verbs and metrics
// 5. File Format (10%) - .docx or plain text

// Score interpretation:
// 90-100: Excellent - Recruiters will see you
// 75-89: Good - Minor tweaks needed
// 60-74: Average - Missing important keywords
// Below 60: Poor - Major overhaul needed

// Goal: 85+ to get past most ATS filters!`,
//   },
// ];

// // Quick questions with emojis and better categorization
// const QUICK_QUESTIONS = [
//   { text: "💰 How much does it cost?", category: "pricing" },
//   { text: "📦 What's included?", category: "features" },
//   { text: "📊 What do the ATS score ranges mean?", category: "ats" },
//   { text: "✨ How does resume generation work?", category: "features" },
//   { text: "🎨 What templates are available?", category: "templates" },
//   { text: "📈 How do I improve my score?", category: "help" },
//   { text: "🔒 Is my data secure?", category: "security" },
//   { text: "💬 How do I contact support?", category: "support" },
//   { text: "🎯 Which plan should I choose?", category: "pricing" },
//   { text: "💵 Can I get a refund?", category: "support" },
//   { text: "📊 Does this actually work?", category: "testimonials" },
//   { text: "🚀 What's coming next?", category: "roadmap" },
//   { text: "🔑 Forgot password?", category: "account" },
// ];

// function matchFAQ(msg) {
//   const lower = msg.toLowerCase();
//   let best = null;
//   let score = 0;
  
//   for (const f of FAQ) {
//     const s = f.keys.filter(k => lower.includes(k)).length;
//     const exactBonus = lower.includes(f.q.toLowerCase()) ? 2 : 0;
//     const totalScore = s + exactBonus;
    
//     if (totalScore > score) { 
//       score = totalScore; 
//       best = f; 
//     }
//   }
  
//   return score > 0 ? best : null;
// }

// export default function ChatWidget() {
//   const [open, setOpen] = useState(false);
//   const [msgs, setMsgs] = useState([]);
//   const [input, setInput] = useState("");
//   const [stage, setStage] = useState("chat");
//   const [pendingQ, setPendingQ] = useState("");
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [formErr, setFormErr] = useState("");
//   const [unread, setUnread] = useState(1);
//   const [typing, setTyping] = useState(false);
//   const [feedbackGiven, setFeedbackGiven] = useState(false);
//   const bottomRef = useRef();
//   const inputRef = useRef();

//   useEffect(() => {
//     bottomRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [msgs, stage, typing]);

//   useEffect(() => {
//     if (open) {
//       setUnread(0);
//       if (msgs.length === 0) {
//         const welcomeMessages = [
//           `Hi! I'm ${APP_NAME}'s assistant. Ask me about pricing, features, templates, or ATS scoring.

// Try asking: "How much does it cost?" or "What do the ATS score ranges mean?"`,
//           `Ready to supercharge your resume? I'm here to help! Ask about ATS scoring, resume templates, or how to improve your score.

// Want to know what a good ATS score looks like? Ask me!`,
//           `Welcome to ${APP_NAME}! Got questions? I've got answers — pricing, features, ATS score standards, templates, technical support.

// Popular questions: What do ATS score ranges mean? How does scoring work?`,
//         ];
//         const randomWelcome = welcomeMessages[Math.floor(Math.random() * welcomeMessages.length)];
//         setMsgs([{ from: "bot", text: randomWelcome, timestamp: new Date() }]);
//       }
//       setTimeout(() => inputRef.current?.focus(), 100);
//     }
//   }, [open, msgs.length]);

//   function addMsg(from, text) {
//     setMsgs(prev => [...prev, { from, text, timestamp: new Date() }]);
//   }

//   async function send(text) {
//     const msg = (text || input).trim();
//     if (!msg) return;
    
//     setInput("");
//     addMsg("user", msg);
//     setTyping(true);

//     setTimeout(() => {
//       setTyping(false);
//       const match = matchFAQ(msg);
      
//       if (match) {
//         addMsg("bot", match.a);
        
//         if (!feedbackGiven && msgs.length > 3 && Math.random() > 0.7) {
//           setTimeout(() => {
//             addMsg("bot", "Was that helpful? If yes - great! If no - use the form below and a human will personally assist you!");
//             setFeedbackGiven(true);
//           }, 1500);
//         }
//       } else {
//         setPendingQ(msg);
//         addMsg("bot", `Great question! I want to make sure you get the best possible answer.

// Leave your name and email below — our support team will personally respond within ${SUPPORT_HR} with a detailed answer.

// Or try rephrasing your question — I might have an answer!`);
//         setStage("collect");
//       }
//     }, 800);
//   }

//   async function submitContact(e) {
//     e.preventDefault();
//     setFormErr("");

//     if (!name.trim()) {
//       setFormErr("Please enter your name");
//       return;
//     }
//     if (!email.trim() || !email.includes("@") || !email.includes(".")) {
//       setFormErr("Please enter a valid email address");
//       return;
//     }
//     if (!pendingQ.trim()) {
//       setFormErr("No question to send");
//       return;
//     }

//     setStage("sending");

//     try {
//       const res = await fetch(`${BACKEND_URL}/email/support`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           firstName: name.split(" ")[0].trim(),
//           lastName: name.split(" ").slice(1).join(" ").trim() || "",
//           email: email.trim(),
//           topic: "Chat Widget Support Question",
//           message: `Question: ${pendingQ}\n\nName: ${name}\nEmail: ${email}\nUser Agent: ${navigator.userAgent}`,
//           userId: "chat_widget",
//         }),
//       });

//       if (!res.ok) throw new Error(`Server returned ${res.status}`);

//       setStage("sent");
//       addMsg("bot", `Perfect ${name.split(" ")[0]}! We've received your question and will reply to ${email} within ${SUPPORT_HR}.

// Check your spam folder just in case!

// Anything else I can help with?`);
//       setName("");
//       setEmail("");
//       setPendingQ("");

//     } catch (err) {
//       console.error("ChatWidget email error:", err);
//       setStage("error");
//       setFormErr(`Couldn't send your message. Please email us directly at ${APP_EMAIL}.`);
//     }
//   }

//   const fieldStyle = {
//     padding: "10px 13px",
//     border: "1.5px solid #e2e8f0",
//     borderRadius: 10,
//     fontSize: 13,
//     outline: "none",
//     fontFamily: "inherit",
//     width: "100%",
//     boxSizing: "border-box",
//     background: "#fafafa",
//     transition: "all 0.2s",
//   };

//   return (
//     <>
//       {/* Floating Button */}
//       <button
//         onClick={() => setOpen(o => !o)}
//         aria-label="Open support chat"
//         style={{
//           position: "fixed", bottom: 24, right: 24, zIndex: 9999,
//           width: 56, height: 56, borderRadius: "50%",
//           background: open ? "#374151" : "linear-gradient(135deg,#2563eb,#1d4ed8)",
//           border: "none", cursor: "pointer",
//           display: "flex", alignItems: "center", justifyContent: "center",
//           boxShadow: "0 8px 28px rgba(37,99,235,0.35)",
//           transition: "all 0.25s",
//         }}
//         onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.08)"; e.currentTarget.style.boxShadow = "0 12px 32px rgba(37,99,235,0.45)"; }}
//         onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0 8px 28px rgba(37,99,235,0.35)"; }}
//       >
//         {open ? (
//           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
//             <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//           </svg>
//         ) : (
//           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//             <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
//           </svg>
//         )}
//         {!open && unread > 0 && (
//           <span style={{
//             position: "absolute", top: -4, right: -4,
//             width: 20, height: 20, borderRadius: "50%",
//             background: "#ef4444", color: "#fff",
//             fontSize: 10, fontWeight: 800,
//             display: "flex", alignItems: "center", justifyContent: "center",
//             border: "2px solid #fff",
//           }}>{unread}</span>
//         )}
//       </button>

//       {/* Chat Window */}
//       {open && (
//         <div style={{
//           position: "fixed", bottom: 92, right: 24, zIndex: 9998,
//           width: 420, maxWidth: "calc(100vw - 32px)",
//           height: 600, maxHeight: "calc(100vh - 110px)",
//           background: "#fff", borderRadius: 20,
//           boxShadow: "0 25px 60px rgba(0,0,0,0.2)",
//           display: "flex", flexDirection: "column",
//           overflow: "hidden",
//           fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
//           animation: "slideUp 0.3s ease",
//         }}>
//           <style>{`
//             @keyframes slideUp {
//               from { opacity: 0; transform: translateY(20px); }
//               to { opacity: 1; transform: translateY(0); }
//             }
//             @keyframes pulse {
//               0%, 100% { opacity: 1; }
//               50% { opacity: 0.5; }
//             }
//             .msg-animation {
//               animation: slideUp 0.2s ease;
//             }
//           `}</style>

//           {/* Header */}
//           <div style={{ background: "linear-gradient(135deg,#0f172a,#1e293b)", padding: "16px 18px", display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
//             <div style={{ width: 40, height: 40, borderRadius: "50%", background: "linear-gradient(135deg,#2563eb,#1d4ed8)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//               <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//                 <circle cx="12" cy="12" r="10"/>
//                 <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
//                 <line x1="12" y1="17" x2="12.01" y2="17"/>
//               </svg>
//             </div>
//             <div style={{ flex: 1 }}>
//               <div style={{ fontWeight: 700, fontSize: 15, color: "#fff" }}>
//                 {APP_NAME} Support
//               </div>
//               <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 3 }}>
//                 <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#22c55e", display: "inline-block", animation: "pulse 2s infinite" }}/>
//                 <span style={{ fontSize: 11, color: "rgba(255,255,255,0.6)" }}>
//                   Online - Usually replies in seconds
//                 </span>
//               </div>
//             </div>
//             <button 
//               onClick={() => setOpen(false)}
//               style={{ 
//                 background: "rgba(255,255,255,0.1)", 
//                 border: "none", 
//                 color: "rgba(255,255,255,0.6)", 
//                 cursor: "pointer", 
//                 padding: "6px 8px", 
//                 borderRadius: 8, 
//                 display: "flex",
//               }}
//               onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.2)"}
//               onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
//             >
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
//                 <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//               </svg>
//             </button>
//           </div>

//           {/* Messages Area */}
//           <div style={{ flex: 1, overflowY: "auto", padding: "16px", display: "flex", flexDirection: "column", gap: 12, background: "#f8fafc" }}>
//             {msgs.map((m, i) => (
//               <div key={i} className="msg-animation" style={{ display: "flex", justifyContent: m.from === "user" ? "flex-end" : "flex-start" }}>
//                 <div style={{
//                   maxWidth: "85%", 
//                   padding: "10px 14px",
//                   borderRadius: m.from === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
//                   background: m.from === "user" ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "#fff",
//                   color: m.from === "user" ? "#fff" : "#1e293b",
//                   fontSize: 13, 
//                   lineHeight: 1.5,
//                   boxShadow: m.from === "bot" ? "0 2px 8px rgba(0,0,0,0.06)" : "0 2px 8px rgba(37,99,235,0.2)",
//                   border: m.from === "bot" ? "1px solid #e2e8f0" : "none",
//                   whiteSpace: "pre-wrap",
//                   wordBreak: "break-word",
//                 }}>
//                   {m.text}
//                 </div>
//               </div>
//             ))}
            
//             {typing && (
//               <div className="msg-animation" style={{ display: "flex", justifyContent: "flex-start" }}>
//                 <div style={{ background: "#fff", padding: "12px 16px", borderRadius: "18px", border: "1px solid #e2e8f0", display: "flex", gap: 4, alignItems: "center" }}>
//                   <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#94a3b8", animation: "pulse 1.4s infinite" }} />
//                   <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#94a3b8", animation: "pulse 1.4s infinite 0.2s" }} />
//                   <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#94a3b8", animation: "pulse 1.4s infinite 0.4s" }} />
//                 </div>
//               </div>
//             )}

//             {/* Contact Form */}
//             {(stage === "collect" || stage === "error") && (
//               <div className="msg-animation" style={{ background: "#fff", borderRadius: 16, padding: "16px", border: "2px solid #bfdbfe", marginTop: 4 }}>
//                 <div style={{ fontSize: 13, fontWeight: 600, color: "#1e40af", marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
//                     <polyline points="22,6 12,13 2,6"/>
//                   </svg>
//                   <span>We'll reply within {SUPPORT_HR}</span>
//                 </div>
//                 <form onSubmit={submitContact} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//                   <input
//                     style={fieldStyle}
//                     placeholder="Your full name"
//                     value={name}
//                     onChange={e => setName(e.target.value)}
//                   />
//                   <input
//                     style={fieldStyle}
//                     type="email"
//                     placeholder="Your email address"
//                     value={email}
//                     onChange={e => setEmail(e.target.value)}
//                   />
//                   {pendingQ && (
//                     <div style={{ fontSize: 11, color: "#475569", background: "#f1f5f9", borderRadius: 8, padding: "8px 10px" }}>
//                       <strong>Your question:</strong> {pendingQ}
//                     </div>
//                   )}
//                   {formErr && (
//                     <div style={{ fontSize: 12, color: "#dc2626", background: "#fef2f2", borderRadius: 8, padding: "8px 10px" }}>
//                       {formErr}
//                     </div>
//                   )}
//                   <button 
//                     type="submit"
//                     style={{ 
//                       padding: "11px", 
//                       background: "linear-gradient(135deg,#2563eb,#1d4ed8)", 
//                       color: "#fff", 
//                       border: "none", 
//                       borderRadius: 10, 
//                       fontWeight: 700, 
//                       fontSize: 13, 
//                       cursor: "pointer",
//                     }}
//                   >
//                     Send Question
//                   </button>
//                   <button 
//                     type="button" 
//                     onClick={() => { setStage("chat"); setPendingQ(""); setFormErr(""); }}
//                     style={{ padding: "5px", background: "transparent", color: "#94a3b8", border: "none", fontSize: 11, cursor: "pointer", textDecoration: "underline" }}
//                   >
//                     Skip - ask something else
//                   </button>
//                 </form>
//               </div>
//             )}

//             {stage === "sending" && (
//               <div className="msg-animation" style={{ textAlign: "center", color: "#64748b", fontSize: 13, padding: "12px", background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0" }}>
//                 Sending your question...
//               </div>
//             )}

//             <div ref={bottomRef} />
//           </div>

//           {/* Quick Questions */}
//           {msgs.length <= 2 && stage === "chat" && (
//             <div style={{ padding: "12px", borderTop: "1px solid #e2e8f0", background: "#fff", flexShrink: 0 }}>
//               <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600, marginBottom: 8 }}>
//                 Popular Questions
//               </div>
//               <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
//                 {QUICK_QUESTIONS.map(q => (
//                   <button 
//                     key={q.text} 
//                     onClick={() => send(q.text)}
//                     style={{ 
//                       fontSize: 11, 
//                       padding: "5px 12px", 
//                       borderRadius: 20, 
//                       background: "#eff6ff", 
//                       color: "#2563eb", 
//                       border: "1px solid #bfdbfe", 
//                       cursor: "pointer", 
//                       fontWeight: 500,
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {q.text}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Input Area */}
//           {(stage === "chat" || stage === "sent") && (
//             <div style={{ padding: "12px", borderTop: "1px solid #e2e8f0", background: "#fff", display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
//               <input
//                 ref={inputRef}
//                 value={input}
//                 onChange={e => setInput(e.target.value)}
//                 onKeyDown={e => e.key === "Enter" && !e.shiftKey && send()}
//                 placeholder="Type your question..."
//                 style={{ 
//                   flex: 1, 
//                   padding: "10px 14px", 
//                   border: "1.5px solid #e2e8f0", 
//                   borderRadius: 24, 
//                   fontSize: 13, 
//                   outline: "none", 
//                   fontFamily: "inherit", 
//                   background: "#f8fafc",
//                 }}
//               />
//               <button 
//                 onClick={() => send()}
//                 disabled={!input.trim()}
//                 style={{ 
//                   width: 38, 
//                   height: 38, 
//                   borderRadius: "50%", 
//                   background: input.trim() ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "#e2e8f0", 
//                   border: "none", 
//                   cursor: input.trim() ? "pointer" : "default", 
//                   display: "flex", 
//                   alignItems: "center", 
//                   justifyContent: "center", 
//                   flexShrink: 0,
//                 }}
//               >
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={input.trim() ? "#fff" : "#94a3b8"} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//                   <line x1="22" y1="2" x2="11" y2="13"/>
//                   <polygon points="22 2 15 22 11 13 2 9 22 2"/>
//                 </svg>
//               </button>
//             </div>
//           )}

//           {/* Footer */}
//           <div style={{ padding: "6px 12px 8px", background: "#fff", textAlign: "center", flexShrink: 0, borderTop: "1px solid #f8fafc" }}>
//             <span style={{ fontSize: 10, color: "#cbd5e1" }}>{APP_NAME}</span>
//             <a href="/support" style={{ fontSize: 10, color: "#94a3b8", textDecoration: "none", marginLeft: 4 }}>
//               Support
//             </a>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// new Q&A added for spam email infor
// eslint-disable-next-line no-unused-vars
import { useState, useEffect, useRef, useCallback } from "react";
import servicesConfig from "../utils/servicesConfig";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";

// ── Pull live values from config so FAQ never goes stale ──
const cfg        = servicesConfig.app;
const basicPlan  = servicesConfig.plans.find(p => p.id === "ats_basic");
const docPlan    = servicesConfig.plans.find(p => p.id === "doc_pro");
const templates  = servicesConfig.resumeTemplates.filter(t => t.active && !t.comingSoon);
const PRICE      = basicPlan?.price        || "$2.99";
const ANALYSES   = basicPlan?.analysisCount || 2;
const RESUME_GEN = basicPlan?.resumeGenCount || 1;
const TMPL_COUNT = templates.length;
const SUPPORT_HR = cfg.supportHours        || "2-4 hours";
const APP_NAME   = cfg.name                || "ResumeScoreAI";
const APP_EMAIL  = cfg.email               || "support@smartaicareer.com";

// Track which questions have been answered to prevent repetition
let answeredQuestions = new Set();

// ── FAQ with clean, simple responses ──
const FAQ = [
  // ============================================================
  // ATS SCORE CALCULATION - HIGHEST PRIORITY
  // ============================================================
  {
    keys: ["calculate", "calculation", "how calculated", "score calculation", "formula", "scoring algorithm", "how do you calculate", "computed", "determined", "ats calculation", "score computed", "how is score calculated"],
    q: "📊 How is my ATS score calculated?",
    a: `Great question! Here's exactly how your ATS score is calculated:

**The Formula (5 factors):**

📈 **1. Keyword Match (40% of score)**
- We extract keywords from the job description
- We check which keywords appear in your resume
- Your match percentage × 0.4 = keyword score
- Example: 85% match → 34 points

📝 **2. Resume Quality (20% of score)**
- Professional summary present? (+5 points)
- Quantifiable achievements (numbers, %, $)? (+5 points)
- Complete sections (Experience + Education + Skills)? (+4 points)
- Contact information? (+3 points)
- Proper word count (400-1200 words)? (+3 points)

🎨 **3. Formatting (15% of score)**
- Standard section headings
- Clean layout without tables/columns
- ATS-friendly font and spacing

💪 **4. Bullet Points (15% of score)**
- Action verbs used
- Metrics and results included
- Job-specific keywords in context

📄 **5. File Format (10% of score)**
- .docx or plain text recommended
- PDF can sometimes cause parsing issues

**Example Calculation:**
- 85% keyword match → 34 points
- Quality score: 15/20 points
- Formatting: 12/15 points
- Bullets: 11/15 points
- File format: 9/10 points
- Total = 81/100 → Good ATS Score

**Score Interpretation:**
- 90-100: Exceptional - Recruiters will definitely see you
- 80-89: Strong - You'll pass most ATS filters
- 70-79: Fair - Needs some improvements
- Below 70: Poor - High risk of being filtered

Would you like tips to improve your score? Just ask! 😊`,
  },

  // ============================================================
  // ATS SCORE MEANING
  // ============================================================
  {
    keys: ["score meaning", "what does score mean", "score interpretation", "score ranges", "good score", "bad score", "score range meaning", "interpretation"],
    q: "📊 What do the ATS score ranges mean?",
    a: `Here's what each ATS score range means for your job search:

**95-100 (Exceptional - Top of Pile)** 🌟
- Recruiters will definitely see your resume
- You rank in the top tier of applicants

**90-94 (Strong - Recruiter Ready)** ✅
- Your resume meets recruiter attention thresholds
- You're in the top 15% of applicants

**85-89 (Good - Competitive)** 📈
- Solid foundation, passes most ATS filters
- Most users reach this after optimization

**75-84 (Fair - Needs Minor Work)** 🔧
- Borderline - some ATS will filter you out
- One round of improvements typically fixes this

**60-74 (Below Average - Needs Improvement)** ⚠️
- High risk of being filtered out
- Missing important keywords

**Below 60 (Poor - High Rejection Risk)** 🚨
- Most ATS systems reject automatically
- Complete overhaul recommended

**Industry Benchmarks:**
- Tech / Software: 88+ to stand out
- Finance / Banking: 85+ to pass
- Healthcare: 82+ to be seen
- Marketing: 80+ to compete

**Your goal: Reach 85+ for interview invites!** 🎯`,
  },

  // ============================================================
  // IMPROVE SCORE
  // ============================================================
  {
    keys: ["improve score", "increase score", "raise score", "better score", "how to improve", "score improvement", "fix score", "boost score"],
    q: "📈 How do I improve my ATS score?",
    a: `I'd love to help you improve your score! Here's a proven plan:

**Step 1: Check Missing Keywords** 🔍
- Look at your analysis report
- Find the "Missing Keywords" section
- These are words employers specifically want

**Step 2: Add Keywords Naturally** ✏️
- DON'T just list them (looks spammy)
- DO weave them into your bullet points
- Example: "Managed cross-functional teams" (adds "cross-functional")

**Step 3: Strengthen Bullet Points** 💪
- Start with action verbs (Led, Created, Improved)
- Add numbers and percentages
- Example: "Improved efficiency by 25%"

**Step 4: Fix Formatting** 📝
- Use standard section headings
- Avoid tables, columns, and graphics
- Save as .docx or plain text

**Step 5: Re-analyze** 🔄
- Use another analysis credit
- See your new score
- Most users improve 20-40 points!

**Quick Wins (do these first):**
1. Add a professional summary
2. Include 3-5 metrics per job
3. Match job title exactly

Want me to explain any of these steps in more detail? 😊`,
  },

  // ============================================================
  // EMAIL & VERIFICATION FAQs
  // ============================================================
  {
    keys: ["verification email", "verify email", "confirm email", "email verification", "email not received", "didn't get email", "verification link", "didn't receive verification", "no verification email", "verify account"],
    q: "📧 I didn't receive the verification email - what should I do?",
    a: `Don't worry, this happens sometimes! Here's what to do:

**Step 1: Check Spam/Junk Folder** 🔍
Most verification emails end up in spam. Please check your spam/junk folder first - 90% of the time it's there!

**Step 2: Add us to Contacts** 📇
Add ${APP_EMAIL} to your email contacts - this helps future emails land in your inbox.

**Step 3: Wait 2-3 minutes** ⏱️
Sometimes email servers take a few minutes to deliver.

**Step 4: Request a new link** 🔄
Go back to the sign-up page and click "Resend Verification Email"

**Step 5: Still not there?** 📧
Email us at ${APP_EMAIL} with your email address and we'll help you verify your account.

**Pro tip:** Always check spam FIRST! Most verification emails hide there.`,
  },
  {
    keys: ["spam", "junk", "email in spam", "spam folder", "email going to spam", "why spam", "in spam", "went to spam", "spam folder check"],
    q: "📨 Why are your emails going to my spam folder?",
    a: `I understand the frustration! Here's why this happens:

**Why emails go to spam:**
- Your email provider's spam filter is extra strict
- First-time sender (our domain is newer)
- Links in emails can trigger spam filters

**How to fix it (takes 30 seconds):**

✅ **Add us to your contacts:**
Save ${APP_EMAIL} to your address book

✅ **Mark as "Not Spam":**
If you find our email in spam, click "Not Spam" or "Report Not Spam"

✅ **Check these folders:**
- Gmail: Also check "Promotions" and "Social" tabs
- Outlook: Check "Junk Email" and "Clutter"
- Yahoo: Check "Spam" folder

**Important:** After marking as "Not Spam", our future emails will go to your inbox!

Hope this helps! 😊`,
  },
  {
    keys: ["payment confirmation", "payment email", "receipt", "payment receipt", "didn't get receipt", "confirmation email", "stripe receipt", "no receipt", "no confirmation email", "payment receipt missing"],
    q: "💳 I paid but didn't get the confirmation email",
    a: `Let me help you find your payment confirmation:

**Step 1: Check Spam Folder** 🔍
Payment confirmation emails often go to spam. Please check your spam/junk folder first!

**Step 2: Search your email** 🔎
Search for: "receipt", "stripe", or "${APP_NAME}"

**Step 3: Check your bank statement** 💳
- If charged, your payment was successful
- You should have access to the service immediately
- The email is just a receipt

**Step 4: Still no email?** 📧
Email us at ${APP_EMAIL} with:
- Your email address
- Approximate payment time
- Last 4 digits of card used

**Important:** Your payment access is INSTANT! You can use the service right away even without the email receipt.`,
  },
  {
    keys: ["whitelist", "safe sender", "add to contacts", "allowlist", "trusted sender", "mark as safe", "whitelist email"],
    q: "📬 How do I whitelist your emails?",
    a: `Here's how to whitelist our emails so you never miss important messages:

**Add these addresses to your contacts:**
• ${APP_EMAIL}
• noreply@stripe.com (for payment receipts)

**Quick guides by email provider:**

**Gmail:**
1. Open an email from us (check spam first)
2. Click the three dots (⋮)
3. Select "Filter messages like this"
4. Click "Create filter"
5. Check "Never send it to Spam"
6. Click "Create filter"

**Outlook:**
1. Go to Settings → "View all Outlook settings"
2. Click "Mail" → "Junk email"
3. Add ${APP_EMAIL} to "Safe senders and domains"
4. Click Save

**Yahoo:**
1. Open an email from us
2. Click the three dots (⋮)
3. Select "Add sender to contacts"
4. Click "Save"

**Done!** Future emails will go straight to your inbox. 🎉`,
  },

  // ============================================================
  // PRICING & PLANS
  // ============================================================
  {
    keys: ["price", "cost", "how much", "fee", "charge", "dollar", "$", "pricing", "payment amount"],
    q: "💰 How much does it cost?",
    a: `${APP_NAME} is just ${PRICE} — a one-time payment with NO subscription ever!

**What you get:**
• ${ANALYSES} full ATS analyses
• ${RESUME_GEN} AI-improved resume
• ${TMPL_COUNT} professional templates
• Instant results in 30 seconds

**That's less than a coffee!** ☕

No monthly fees, no hidden charges, no auto-renewals. Pay once and use your credits whenever you need them.

Ready to get started? Head to the Pricing page! 😊`,
  },
  {
    keys: ["subscription", "monthly", "recurring", "cancel", "automatic", "renew", "billing", "auto-renew"],
    q: "🔄 Is there a subscription?",
    a: `**No subscriptions — EVER!** 🙌

✅ One-time payment only
✅ No hidden fees or surprises
✅ No automatic renewals
✅ Keep what you buy forever

Pay once, use your credits whenever you want, and that's it. Simple and fair.

Many services charge $20-50/month, but we believe in a fair one-time payment. You shouldn't have to pay forever for a resume!

Is there anything else you'd like to know? 😊`,
  },
  {
    keys: ["document pro", "doc pro", "second plan", "upgrade", "document summary", "pro plan"],
    q: "📊 What about Document Pro?",
    a: docPlan && docPlan.active
      ? `Document Pro is ${docPlan.price} one-time! 🚀

**Includes:**
• ${docPlan.analysisCount || 3} ATS analyses
• AI document summarization with charts
• Document chat Q&A (ask questions about your document!)
• ${RESUME_GEN} AI resume

Perfect for analyzing reports, research papers, contracts, or long documents!`
      : `Document Pro is coming soon! 🎉 

**Will include:**
• AI document summarization with visual charts
• Interactive document chat and Q&A
• ${ANALYSES * 2} ATS analyses

Want early access? Email us at ${APP_EMAIL} and we'll notify you when it launches!`,
  },

  // ============================================================
  // FEATURES & TEMPLATES
  // ============================================================
  {
    keys: ["include", "what do i get", "features", "what's included", "package", "included", "includes"],
    q: "📦 What's included in ATS Basic?",
    a: `Here's everything included in ATS Basic (${PRICE}):

**📊 Analyses (${ANALYSES} total):**
- Full ATS score (0-100)
- Keyword gap analysis
- Section-by-section feedback
- AI rewrite suggestions
- Downloadable PDF report

**✨ Resume Generation (${RESUME_GEN}):**
- AI-improved resume using YOUR real data
- ${TMPL_COUNT} professional templates
- PDF + Word + HTML download options
- ATS-optimized formatting

**Total value: ~$50 — you pay just ${PRICE}!** 🎉

No subscription, no hidden fees, instant results!`,
  },
  {
    keys: ["resume", "generate", "generator", "template", "improved", "ai resume", "optimize", "resume generator"],
    q: "✨ How does the AI resume generator work?",
    a: `The AI resume generator works in 3 simple steps:

**Step 1: Analysis** 🔍
We scan your resume against the job description to find what's missing

**Step 2: Enhancement** ✨
Our AI injects missing keywords naturally into your real experience (no generic filler!)

**Step 3: Generation** 🎨
You pick from ${TMPL_COUNT} beautiful templates and download instantly

**Total time: 15-20 seconds!**

**Templates available:**
${templates.map(t => `• ${t.name} - ${t.description}`).join("\n")}

**Best part:** We keep YOUR real experience, companies, and dates — we just make it stronger!`,
  },
  {
    keys: ["template", "templates", "designs", "styles", "choices", "look", "appearance", "template options"],
    q: "🎨 What templates are available?",
    a: `We have ${TMPL_COUNT} professional ATS-tested templates:

${templates.map((t, i) => `${i+1}. **${t.name}** - ${t.description}`).join("\n")}

**All templates:**
✅ Pass ATS scanners (Workday, Greenhouse, Taleo)
✅ Export to PDF, Word, and HTML
✅ Mobile-responsive design
✅ Recruiter-approved formatting

**How to choose:**
- Finance/Law → Classic or Professional
- Tech/Creative → Modern or Bold
- Executive → Executive or Professional
- Minimalist → Minimal Clean

You can preview all templates before downloading!`,
  },

  // ============================================================
  // ACCOUNT
  // ============================================================
  {
    keys: ["account", "sign up", "login", "register", "create", "registration", "create account"],
    q: "📝 Do I need an account?",
    a: `Yes, but it's quick and FREE! Takes under 1 minute:

**What you need:**
1. Name (first + last)
2. Email address
3. Password

**Why create an account?**
- Store all your analyses and resumes
- Access from any device
- Track your progress over time
- View payment history
- One-click re-analysis

**No credit card required for account creation!**

Ready to start? Head to the Sign Up page! 😊`,
  },
  {
    keys: ["forgot password", "reset password", "locked out", "can't login", "login problem", "password reset", "forgotten password"],
    q: "🔑 I forgot my password",
    a: `No worries - happens to everyone! Here's how to reset it:

**Reset in 3 steps:**

1. Click "Forgot Password" on the login page
2. Enter your email address
3. Check your inbox (AND spam folder!)

**Important notes:**
- The reset link expires in 1 hour
- Check your spam folder if you don't see it
- Add ${APP_EMAIL} to your contacts for faster delivery

**Still stuck?** Email us at ${APP_EMAIL} and we'll help you out!`,
  },
  {
    keys: ["delete account", "remove data", "cancel account", "close account", "erase", "delete my account"],
    q: "🗑️ How do I delete my account?",
    a: `We're sad to see you go, but here's how to delete your account:

**Steps to delete:**
1. Go to Account Settings
2. Scroll to "Danger Zone"
3. Click "Delete Account"
4. Confirm your choice

**What happens:**
- All your data is permanently deleted within 24 hours
- This cannot be undone
- Your payment history is anonymized

**Questions before you go?** Email us at ${APP_EMAIL} - we'd love to help if there's an issue we can fix!`,
  },

  // ============================================================
  // GENERAL GREETINGS & POLITE RESPONSES
  // ============================================================
  {
    keys: ["hello", "hi", "hey", "greetings", "good morning", "good afternoon", "good evening", "howdy", "hola", "sup", "hey there"],
    q: "👋 Hello!",
    a: `Hello there! Welcome to ${APP_NAME}! 👋

I'm your AI assistant. I can help with:
- 💰 Pricing and plans
- 🎨 Templates and design
- 📊 ATS scoring and calculation
- 📧 Email issues (verification, spam, receipts)
- 🔧 How to use the platform

**Try asking:**
- "How much does it cost?"
- "How is my ATS score calculated?"
- "Didn't get verification email?"
- "How do I improve my score?"

What can I help you with today? 😊`,
  },
  {
    keys: ["thanks", "thank you", "appreciate", "grateful", "thx", "cheers", "thanks a lot", "many thanks", "thank", "ty", "appreciated", "much appreciated"],
    q: "🙏 Thank you!",
    a: `You're very welcome! 😊

I'm glad I could help! That's what I'm here for.

**Ready to take the next step?**
- Head to the Dashboard
- Upload your resume
- Get your ATS score in 30 seconds

Good luck with your job search - you've got this! 💪

Feel free to come back anytime if you have more questions!`,
  },
  {
    keys: ["good", "awesome", "great", "nice", "cool", "love it", "amazing", "fantastic", "wonderful", "excellent", "perfect", "beautiful"],
    q: "😊 That's great!",
    a: `I'm so glad to hear that! 🎉

**Here's what to do next:**

1. **Create a free account** (if you haven't already)
2. **Upload your resume** - paste text or upload .docx
3. **Paste a job description** - from any job board
4. **Get your ATS score** - plus missing keywords
5. **Generate your improved resume** - pick a template!

**Total time: Under 5 minutes**

You're on your way to a better resume and more interviews!

Ready to start? Go to Dashboard! 🚀`,
  },
  {
    keys: ["error", "broken", "not working", "bug", "failed", "crash", "problem", "issue", "glitch", "something wrong"],
    q: "🐛 Something isn't working",
    a: `I'm sorry you're experiencing issues! Let's try to fix it:

**Quick troubleshooting (works 90% of the time):**

1. **Refresh the page** 🔄 - Solves most issues
2. **Clear your browser cache** 🧹 - Removes old data
3. **Try a different browser** 🌐 - Chrome or Firefox work best
4. **Disable ad blockers** 🚫 - They can interfere

**Still having issues?** Please email us at ${APP_EMAIL} with:
- What happened (describe the issue)
- Any error messages you saw
- Your browser and device

We'll get back to you as soon as possible!`,
  },

  // ============================================================
  // CONTACT/SUPPORT - LAST RESORT
  // ============================================================
  {
    keys: ["contact", "email support", "reach", "question not answered", "need more help"],
    q: "📧 How can I contact support?",
    a: `You can reach us by email at **${APP_EMAIL}**

**When to email:**
- You have a technical issue I couldn't solve
- You need help with a payment
- You want to request a feature
- You have a question I couldn't answer

**Before emailing:**
- Try asking me your question in different words - I might know the answer!
- Check our FAQ (I have answers to most common questions)

**Response time:** Usually within ${SUPPORT_HR}

Is there something specific I can help you with right now? 😊`,
  },
];

// Helper function to find the best matching FAQ
function matchFAQ(msg) {
  const lower = msg.toLowerCase().trim();
  
  // Special handling for thanks - only respond once
  if ((lower.includes("thank") || lower.includes("thanks") || lower === "ty" || lower === "thx") && !answeredQuestions.has("thank_you")) {
    answeredQuestions.add("thank_you");
    return FAQ.find(f => f.keys.includes("thank you"));
  }
  
  let bestMatch = null;
  let bestScore = 0;
  
  for (const faq of FAQ) {
    // Skip already answered questions
    if (answeredQuestions.has(faq.q)) continue;
    
    let score = 0;
    
    // Exact question match - highest priority
    if (lower.includes(faq.q.toLowerCase())) {
      score = 100;
    } else {
      // Keyword matching
      for (const key of faq.keys) {
        if (lower.includes(key)) {
          // Longer keywords get higher weight
          const weight = Math.min(key.length / 5, 3);
          score += weight;
        }
      }
      
      // Boost score for ATS-related questions
      if (lower.includes("ats") || lower.includes("score")) {
        if (faq.q.includes("ATS")) score += 3;
      }
      
      // Boost for email-related questions
      if (lower.includes("email") || lower.includes("spam") || lower.includes("verification")) {
        if (faq.q.includes("email") || faq.q.includes("spam")) score += 3;
      }
    }
    
    if (score > bestScore && score > 0) {
      bestScore = score;
      bestMatch = faq;
    }
  }
  
  // Mark as answered if score is good enough
  if (bestMatch && bestScore >= 1) {
    answeredQuestions.add(bestMatch.q);
  }
  
  // Reset answered questions occasionally
  if (answeredQuestions.size > 20) {
    answeredQuestions.clear();
  }
  
  return bestMatch;
}

// Polite fallback response for questions not in FAQ
function getPoliteFallbackResponse(question) {
  return `I appreciate your question! While I don't have an answer for that specifically, here's what you can do:

**📧 Email our support team:** ${APP_EMAIL}
They'll get back to you within ${SUPPORT_HR}

**💡 Try rephrasing your question** - I might understand it better!

**Popular questions I can answer:**
- "How is my ATS score calculated?"
- "How much does it cost?"
- "Didn't get verification email?"
- "How do I improve my score?"

Is there something else I can help you with? 😊`;
}

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [input, setInput] = useState("");
  const [stage, setStage] = useState("chat");
  const [pendingQ, setPendingQ] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [formErr, setFormErr] = useState("");
  const [unread, setUnread] = useState(1);
  const [typing, setTyping] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const bottomRef = useRef();
  const inputRef = useRef();

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [msgs, stage, typing]);

  useEffect(() => {
    if (open) {
      setUnread(0);
      if (msgs.length === 0) {
        answeredQuestions.clear();
        
        const welcomeMessages = [
          `Hi! I'm ${APP_NAME}'s AI assistant. I can help with pricing, ATS scoring, templates, and email issues.

**Try asking:**
• "How is my ATS score calculated?"
• "How much does it cost?"
• "Didn't get verification email?"
• "How do I improve my score?"

What can I help you with today? 😊`,
          
          `Welcome to ${APP_NAME}! 👋

I can help you with:
- 💰 Pricing (just ${PRICE} one-time!)
- 📊 ATS score calculation
- 📧 Email verification issues
- 🎨 Resume templates
- 🔧 How to use the platform

What would you like to know? 😊`,
          
          `Hello! I'm your ${APP_NAME} AI assistant. 

**Popular questions I can answer:**
• "How do you calculate ATS score?"
• "Why are emails going to spam?"
• "What templates are available?"
• "How do I improve my score?"

Feel free to ask me anything! 😊`,
        ];
        const randomWelcome = welcomeMessages[Math.floor(Math.random() * welcomeMessages.length)];
        setMsgs([{ from: "bot", text: randomWelcome, timestamp: new Date() }]);
      }
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [open, msgs.length]);

  function addMsg(from, text) {
    setMsgs(prev => [...prev, { from, text, timestamp: new Date() }]);
  }

  async function send(text) {
    const msg = (text || input).trim();
    if (!msg) return;
    if (isProcessing) return;
    
    setIsProcessing(true);
    setInput("");
    addMsg("user", msg);
    setTyping(true);

    setTimeout(() => {
      setTyping(false);
      const match = matchFAQ(msg);
      
      if (match) {
        addMsg("bot", match.a);
      } else {
        // Use polite fallback response without human support claim
        setPendingQ(msg);
        const fallbackMsg = getPoliteFallbackResponse(msg);
        addMsg("bot", fallbackMsg);
        setStage("collect");
      }
      
      setIsProcessing(false);
    }, 600);
  }

  async function submitContact(e) {
    e.preventDefault();
    if (isProcessing) return;
    setIsProcessing(true);
    setFormErr("");

    if (!name.trim()) {
      setFormErr("Please enter your name");
      setIsProcessing(false);
      return;
    }
    if (!email.trim() || !email.includes("@") || !email.includes(".")) {
      setFormErr("Please enter a valid email address");
      setIsProcessing(false);
      return;
    }
    if (!pendingQ.trim()) {
      setFormErr("No question to send");
      setIsProcessing(false);
      return;
    }

    setStage("sending");

    try {
      const res = await fetch(`${BACKEND_URL}/email/support`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          firstName: name.split(" ")[0].trim(),
          lastName: name.split(" ").slice(1).join(" ").trim() || "",
          email: email.trim(),
          topic: "Chat Widget Question",
          message: `Question: ${pendingQ}\n\nName: ${name}\nEmail: ${email}\nUser Agent: ${navigator.userAgent}`,
          userId: "chat_widget",
        }),
      });

      if (!res.ok) throw new Error(`Server returned ${res.status}`);

      setStage("sent");
      addMsg("bot", `Thank you ${name.split(" ")[0]}! 🙏

I've sent your question to ${APP_EMAIL}. Our team will email you back within ${SUPPORT_HR}.

**💡 Important:** Please check your spam/junk folder for our response!

Is there anything else I can help you with in the meantime? 😊`);
      setName("");
      setEmail("");
      setPendingQ("");

    } catch (err) {
      console.error("ChatWidget email error:", err);
      setStage("error");
      setFormErr(`Sorry, we couldn't send your message. Please email us directly at ${APP_EMAIL}.`);
    } finally {
      setIsProcessing(false);
    }
  }

  const fieldStyle = {
    padding: "10px 13px",
    border: "1.5px solid #e2e8f0",
    borderRadius: 10,
    fontSize: 13,
    outline: "none",
    fontFamily: "inherit",
    width: "100%",
    boxSizing: "border-box",
    background: "#fafafa",
    transition: "all 0.2s",
  };

  const quickQuestions = [
    { text: "📊 How is ATS score calculated?", category: "ats" },
    { text: "💰 How much does it cost?", category: "pricing" },
    { text: "📈 How do I improve my score?", category: "ats" },
    { text: "📧 Didn't get verification email?", category: "email" },
    { text: "📨 Emails going to spam?", category: "email" },
    { text: "💳 Payment confirmation missing?", category: "payment" },
    { text: "🎨 What templates are available?", category: "templates" },
    { text: "🔑 Forgot password?", category: "account" },
  ];

  return (
    <>
      <button
        onClick={() => setOpen(o => !o)}
        aria-label="Open support chat"
        style={{
          position: "fixed", bottom: 24, right: 24, zIndex: 9999,
          width: 56, height: 56, borderRadius: "50%",
          background: open ? "#374151" : "linear-gradient(135deg,#2563eb,#1d4ed8)",
          border: "none", cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 8px 28px rgba(37,99,235,0.35)",
          transition: "all 0.25s",
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.08)"; e.currentTarget.style.boxShadow = "0 12px 32px rgba(37,99,235,0.45)"; }}
        onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0 8px 28px rgba(37,99,235,0.35)"; }}
      >
        {open ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
          </svg>
        )}
        {!open && unread > 0 && (
          <span style={{
            position: "absolute", top: -4, right: -4,
            width: 20, height: 20, borderRadius: "50%",
            background: "#ef4444", color: "#fff",
            fontSize: 10, fontWeight: 800,
            display: "flex", alignItems: "center", justifyContent: "center",
            border: "2px solid #fff",
          }}>{unread}</span>
        )}
      </button>

      {open && (
        <div style={{
          position: "fixed", bottom: 92, right: 24, zIndex: 9998,
          width: 420, maxWidth: "calc(100vw - 32px)",
          height: 600, maxHeight: "calc(100vh - 110px)",
          background: "#fff", borderRadius: 20,
          boxShadow: "0 25px 60px rgba(0,0,0,0.2)",
          display: "flex", flexDirection: "column",
          overflow: "hidden",
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          animation: "slideUp 0.3s ease",
        }}>
          <style>{`
            @keyframes slideUp {
              from { opacity: 0; transform: translateY(20px); }
              to { opacity: 1; transform: translateY(0); }
            }
            @keyframes pulse {
              0%, 100% { opacity: 1; }
              50% { opacity: 0.5; }
            }
            .msg-animation {
              animation: slideUp 0.2s ease;
            }
          `}</style>

          {/* Header */}
          <div style={{ background: "linear-gradient(135deg,#0f172a,#1e293b)", padding: "16px 18px", display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
            <div style={{ width: 40, height: 40, borderRadius: "50%", background: "linear-gradient(135deg,#2563eb,#1d4ed8)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: "#fff" }}>
                {APP_NAME} Assistant
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 3 }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#22c55e", display: "inline-block", animation: "pulse 2s infinite" }}/>
                <span style={{ fontSize: 11, color: "rgba(255,255,255,0.6)" }}>
                  AI Assistant - Here to help!
                </span>
              </div>
            </div>
            <button 
              onClick={() => setOpen(false)}
              style={{ 
                background: "rgba(255,255,255,0.1)", 
                border: "none", 
                color: "rgba(255,255,255,0.6)", 
                cursor: "pointer", 
                padding: "6px 8px", 
                borderRadius: 8, 
                display: "flex",
              }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.2)"}
              onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>

          {/* Messages Area */}
          <div style={{ flex: 1, overflowY: "auto", padding: "16px", display: "flex", flexDirection: "column", gap: 12, background: "#f8fafc" }}>
            {msgs.map((m, i) => (
              <div key={i} className="msg-animation" style={{ display: "flex", justifyContent: m.from === "user" ? "flex-end" : "flex-start" }}>
                <div style={{
                  maxWidth: "85%", 
                  padding: "10px 14px",
                  borderRadius: m.from === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
                  background: m.from === "user" ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "#fff",
                  color: m.from === "user" ? "#fff" : "#1e293b",
                  fontSize: 13, 
                  lineHeight: 1.5,
                  boxShadow: m.from === "bot" ? "0 2px 8px rgba(0,0,0,0.06)" : "0 2px 8px rgba(37,99,235,0.2)",
                  border: m.from === "bot" ? "1px solid #e2e8f0" : "none",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}>
                  {m.text}
                </div>
              </div>
            ))}
            
            {typing && (
              <div className="msg-animation" style={{ display: "flex", justifyContent: "flex-start" }}>
                <div style={{ background: "#fff", padding: "12px 16px", borderRadius: "18px", border: "1px solid #e2e8f0", display: "flex", gap: 4, alignItems: "center" }}>
                  <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#94a3b8", animation: "pulse 1.4s infinite" }} />
                  <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#94a3b8", animation: "pulse 1.4s infinite 0.2s" }} />
                  <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#94a3b8", animation: "pulse 1.4s infinite 0.4s" }} />
                </div>
              </div>
            )}

            {/* Contact Form - Only shown when AI can't answer */}
            {(stage === "collect" || stage === "error") && (
              <div className="msg-animation" style={{ background: "#fff", borderRadius: 16, padding: "16px", border: "2px solid #bfdbfe", marginTop: 4 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#1e40af", marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                  <span>Email our support team</span>
                </div>
                <form onSubmit={submitContact} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  <input
                    style={fieldStyle}
                    placeholder="Your full name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                  />
                  <input
                    style={fieldStyle}
                    type="email"
                    placeholder="Your email address"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                  {pendingQ && (
                    <div style={{ fontSize: 11, color: "#475569", background: "#f1f5f9", borderRadius: 8, padding: "8px 10px" }}>
                      <strong>Your question:</strong> {pendingQ}
                    </div>
                  )}
                  {formErr && (
                    <div style={{ fontSize: 12, color: "#dc2626", background: "#fef2f2", borderRadius: 8, padding: "8px 10px" }}>
                      {formErr}
                    </div>
                  )}
                  <button 
                    type="submit"
                    style={{ 
                      padding: "11px", 
                      background: "linear-gradient(135deg,#2563eb,#1d4ed8)", 
                      color: "#fff", 
                      border: "none", 
                      borderRadius: 10, 
                      fontWeight: 700, 
                      fontSize: 13, 
                      cursor: "pointer",
                    }}
                  >
                    Send Email
                  </button>
                  <button 
                    type="button" 
                    onClick={() => { setStage("chat"); setPendingQ(""); setFormErr(""); }}
                    style={{ padding: "5px", background: "transparent", color: "#94a3b8", border: "none", fontSize: 11, cursor: "pointer", textDecoration: "underline" }}
                  >
                    ← Go back to chat
                  </button>
                </form>
              </div>
            )}

            {stage === "sending" && (
              <div className="msg-animation" style={{ textAlign: "center", color: "#64748b", fontSize: 13, padding: "12px", background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0" }}>
                Sending your message... 📧
              </div>
            )}

            <div ref={bottomRef} />
          </div>

          {/* Quick Questions */}
          {msgs.length <= 2 && stage === "chat" && (
            <div style={{ padding: "12px", borderTop: "1px solid #e2e8f0", background: "#fff", flexShrink: 0 }}>
              <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600, marginBottom: 8 }}>
                ✨ Popular Questions - Click to ask
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {quickQuestions.map(q => (
                  <button 
                    key={q.text} 
                    onClick={() => send(q.text)}
                    style={{ 
                      fontSize: 11, 
                      padding: "5px 12px", 
                      borderRadius: 20, 
                      background: "#eff6ff", 
                      color: "#2563eb", 
                      border: "1px solid #bfdbfe", 
                      cursor: "pointer", 
                      fontWeight: 500,
                    }}
                  >
                    {q.text}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Input Area */}
          {(stage === "chat" || stage === "sent") && (
            <div style={{ padding: "12px", borderTop: "1px solid #e2e8f0", background: "#fff", display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
              <input
                ref={inputRef}
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyDown={e => e.key === "Enter" && !e.shiftKey && !isProcessing && send()}
                placeholder="Ask me anything... 😊"
                style={{ 
                  flex: 1, 
                  padding: "10px 14px", 
                  border: "1.5px solid #e2e8f0", 
                  borderRadius: 24, 
                  fontSize: 13, 
                  outline: "none", 
                  fontFamily: "inherit", 
                  background: "#f8fafc",
                }}
              />
              <button 
                onClick={() => send()}
                disabled={!input.trim() || isProcessing}
                style={{ 
                  width: 38, 
                  height: 38, 
                  borderRadius: "50%", 
                  background: input.trim() && !isProcessing ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "#e2e8f0", 
                  border: "none", 
                  cursor: input.trim() && !isProcessing ? "pointer" : "default", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center", 
                  flexShrink: 0,
                }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={input.trim() && !isProcessing ? "#fff" : "#94a3b8"} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="22" y1="2" x2="11" y2="13"/>
                  <polygon points="22 2 15 22 11 13 2 9 22 2"/>
                </svg>
              </button>
            </div>
          )}

          {/* Footer */}
          <div style={{ padding: "6px 12px 8px", background: "#fff", textAlign: "center", flexShrink: 0, borderTop: "1px solid #f8fafc" }}>
            <span style={{ fontSize: 10, color: "#94a3b8" }}>
              {APP_NAME} AI Assistant • 💬 Ask me anything
            </span>
          </div>
        </div>
      )}
    </>
  );
}